import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { DetalleDiasVacacionesSolicitados, FechasPermisosMedicosVacaciones, HoraPermisoVacaciones, horarioAlmuerzoServidor, horarioLaboralServidor, HorarioLaboralServidorPermisosHoras, PlanificacionSolicitudVacaciones, Replanificacion, SolicitudReintegroVacaciones, SolicitudReintegroVacacionesPost, SolicitudReplanificacionVacaciones, SolicitudVacaciones, SolicitudVacacionesAnulacionPost, SolicitudVacacionesPost, TabSolicitudActiva } from './TypesSolicitudVacaciones'

import { Button, Form, FormGroup, Label, Input, Card, CardTitle, CardBody, CardFooter, Container, Row, Col, Table, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from 'classnames';

import Datepicker from 'components/Varios/Datepicker';
import { isWeekday, isFeriadoFilter, isFeriado, } from 'functions/CalendarFunctions';
import { CompareDates, function_calcular_dias_ordinarios, ObtenerFechaFromIsoFormat, obtener_rango_fechas_no_weekend, PruebaSolucion2, SumarDiasFecha, SumarMesesFecha, overlaps_dates, AgregarHoraAFecha, ParseHorasFormato, toHoursAndMinutes, CompareRangeBetweenDatesAlmuerzo, obtener_rango_fechas_horas_no_weekend, GetPreviousLaboralDay, GetNPreviousLaboralDay } from 'functions/DatesFunctions';
import { AnularSolicitudReintegroVacaciones, AnularSolicitudReplanificacionVacaciones, AnularSolicitudVacaciones, AnularSolicitudVacacionesAprobada, ObtenerDetalleDiasSolicitarVacaciones, ObtenerHorarioLaboralEnFecha, ObtenerInformacionDiaPermiso, ObtenerVistaPreviaDocumentoSolicitudReintegroVacaciones, ObtenerVistaPreviaDocumentoSolicitudReplanificacion, ObtenerVistaPreviaDocumentoSolicitudVacaciones, SolicitarReintegroVacaciones, SolicitarVacacionesCreacion, SolicitarVacacionesFormulario } from './FunctionsSolicitudVacaciones';
import { ResponseRequest } from 'components/Types/GeneralTypes';
import AlertNew from 'components/Varios/AlertNew';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import ModalVistaPreviaDocumentosAccion from 'components/Varios/Modals/ModalVistaPreviaDocumento';
import ModalRechazo from "../../../DirectivoUnidad/AprobacionSolicitudes/ModalRechazoSolicitud";
import ModalReintegro from "./Modal Acciones/ModalReintegro";

import { alertService } from 'components/Varios/alert_service';
import Cargando from 'components/Varios/Cargando';
import { ScrollToTop } from 'functions/LayoutFunctionst';
import { EstadoSolicitudReintegro, EstadoSolicitudReplanificacionVacaciones, EstadoSolicitudVacaciones } from 'components/DirectivoUnidad/AprobacionSolicitudes/TypesAprobacionSolicitudes';
import { REGIMEN_USUARIO, VerificarServidorSoloTieneCodigoTrabajo } from 'functions/DatosUsuarioFunctions';
import add from 'date-fns/add'

//Contexto para solicitudes
import { useSolicitudVacacionesContext } from 'Context/SolicitudesVacacionesContext';
import differenceInMinutes from 'date-fns/differenceInMinutes'
import { addDays, differenceInHours, format } from 'date-fns';
import { OPCIONES_SELECT_JUSTIFICACION_PLANIFICACIONES_NO_EJECUTADAS } from './CardReplanificacionJustificacion';
import ModalAccionAnularSolicitudAprobada from './Modal Acciones/ModalAccionAnularSolicitudAprobada';
import { CalcularFraccionHoraDia } from '../../../../functions/VacacionesFunctions';
import ModalCargando from 'components/Varios/ModalCargando';
import { showAlertSwal, showAlertSwalAnuncio } from 'components/Admin/AprobacionesSolicitudes/AprobacionSolicitudesTh';
import { SumarDiasLaboralesFecha } from 'helpers/DateFunctions';
import { TraslapaHoras } from 'functions/TimeFunctions';


type stateCardSolicitudes = {
    // solicitudesIngresadas: SolicitudVacaciones[],
    solicitudesReintegro: SolicitudReintegroVacaciones[],
    fechaDesde: Date | string | null,
    fechaHasta: Date | string | null,
    // fechasEscogidas: Date[],
    loadingCreacion: boolean
}

type stateModal = {
    showModal: boolean,
    solicitud?: SolicitudVacaciones,
    content: HTMLElement | undefined

}


type stateModalAnulacionReintegro = {
    showModal: boolean,
    solicitud?: SolicitudReintegroVacaciones,
    content: HTMLElement | undefined

}

type stateModalVistaPrevia = {
    url: string,
    loadingContenido: boolean,
    tituloModal: string
}

type stateModalFormulario = {
    url: string,
    loadingFormulario: boolean,
    tituloModal: string,
    content: HTMLElement | undefined
}

type stateModalAnularSolicitudAprobada = {
    content: HTMLElement | undefined
    cargando: boolean,
    idSolicitudVacaciones: number,
    solicitudVacacionesAsociada: SolicitudVacaciones | undefined,
    tituloModal: string,
    mensajeBody: string
}


type stateModalSolicitarReintegro = {
    content: HTMLElement | undefined,
    solicitudVacaciones: SolicitudVacaciones,

}

type stateModalAnulaSolicitudReplanificacion = {
    content: HTMLElement | undefined,
    showModal: boolean,
    idSolicitud: number
    // solicitud:SolicitudReplanificacionVacaciones
}




type PropsCardSolicitudes = {
    solicitudes: SolicitudVacaciones[],
    solicitudesReintegro: SolicitudReintegroVacaciones[],
    solicitudReplanificacion: SolicitudReplanificacionVacaciones | null,
    diasPendientes: number,
    anioSolicitud: number,
    feriados: Date[],
    fechasPermisosMedicos: FechasPermisosMedicosVacaciones[],
    fechasLicencia: {
        fechadesde: Date,
        fechahasta: Date
    }[],
    onInsertSolicitud: () => Promise<void>,
    onChangeFechaConPlanificacion: (fechaDesde, fechaHasta) => void,
    solicitudPlanificada?: PlanificacionSolicitudVacaciones,
    planificaciones: PlanificacionSolicitudVacaciones[],
    idRegimenLaboral: number[],
    acuerdoMediosElectronicos: boolean,
    planificacionesNoEjecutadas: PlanificacionSolicitudVacaciones[],
    horarioLaboral: horarioLaboralServidor,
    fechaCorteSoloJustificaPlanificacion: Date,
    nroMaximoDiasOrdinariosImputablesVacaciones: number,
    horarioAlmuerzo: horarioAlmuerzoServidor,
    puedeSolicitarPorHorario: boolean,
    cantidadMinutosMinimosPermisos: number,
    idRegimenLaboralSolicitaVacaciones:number,
    fechafincontrato:null|string
}

type FechaHora = {
    fecha: Date,
    horaInicio: string,
    horaFin: string
}



function ObtenerListadoIdPlanificacionesNoEjecutadas(planificaciones: PlanificacionSolicitudVacaciones[]) {
    const listado = planificaciones.length === 0 ? [] : planificaciones.map((id, indiid) => {
        return id.idPlanificacionVacaciones;
    })
    return listado
}

type FiltrarPermisos = {
    incluirDias: boolean,
    incluirHoras: boolean
}

export function FiltrarVacacionesIngresadas(solicitudes: Array<SolicitudVacaciones>, soloParaReintegro: boolean, incluirPermisos?: FiltrarPermisos) {



    const fechaActual = new Date();
    const filtradas = solicitudes.filter((val) => {

        const fechaDesdeSolicitud = new Date(val.fechaInicio);
        const fechaHastaSolicitud = new Date(val.fechaFin);


        const incluyePermisos = (incluirPermisos?.incluirDias && !incluirPermisos.incluirHoras && val.permiso && val.horadesde === "") || (incluirPermisos?.incluirDias && val.permiso && incluirPermisos.incluirHoras && val.horadesde !== "") || (!incluirPermisos?.incluirDias && val.permiso && incluirPermisos?.incluirHoras && val.horadesde !== "") || (incluirPermisos?.incluirDias && incluirPermisos.incluirHoras && val.permiso)

        return (!val.reintegro
            && ((incluirPermisos !== undefined && incluyePermisos) || (incluirPermisos === undefined && !val.permiso))
            && ((soloParaReintegro && val.estado === (EstadoSolicitudVacaciones.APROBACIONRRHH)
                // && fechaDesdeSolicitud.getTime() < fechaActual.getTime() && fechaActual.getTime() < fechaHastaSolicitud.getTime()
            )
                || !soloParaReintegro)
        )
    }
    );

    return filtradas;


}

export function EsSolicitudVacacionesVigenteParaReintegro(solicitudVacaciones: SolicitudVacaciones) {

    const fechaActual = new Date();
    const fechaDesde = new Date(solicitudVacaciones.fechaInicio);
    const fechaHasta = new Date(solicitudVacaciones.fechaFin);


    return fechaDesde.getTime() <= fechaActual.getTime() && fechaActual.getTime() < fechaHasta.getTime();

}



export default function CardSolicitudes(props: PropsCardSolicitudes) {

    //Constantes mensajes 
    const MENSAJE_CUANDO_SOLICITA_PERMISO_IMPUTABLE: string = "Ud. va a tomar vacaciones no planificadas. Acepte la justificación.";

    const MENSAJE_ADVERTENCIA_USO_MEDIOS_ELECTRONICOS: string = "La solicitud no puede ser envíada por este medio porque no ha firmado el acuerdo de medios electrónicos. Por lo tanto, luego de dar click en aceptar, debe imprimir la presente solicitud, hacerla firmar físicamente por el directivo de su unidad y entregarla en la Unidad de Talento Humano";
    const MENSAJE_JUSTIFICAR_VACACIONES_NO_PLANIFICADAS: string = "Ud. tiene vacaciones planificadas no ejecutadas. Favor seleccione la justificación, en común acuerdo con su Directivo."
    const NUMERO_DIAS_MAXIMO_PERMISO: number = 22

    const MENSAJE_ERROR_LIMITES_HORARIO_LABORAL: string = "Las horas de permiso deben estar dentro del rango de su horario de trabajo";
    const MENSAJE_ERROR_DIA_COMPLETO_PERMISO_HORAS: string = "Ud está solicitando un día de permiso, en la opción de permisos por horas.  Favor utilice la opción de permisos por días";


    const OPCIONES_SELECT_JUSTIFICACION_PERMISO: string[] = ["Asuntos Personales"];
    const DEFAULT_JUSTIFICACION_PERMISO: string = OPCIONES_SELECT_JUSTIFICACION_PERMISO[0];
    const DEFAULT_JUSTIFICACION_PLANIFICACIONES_NO_EJECUTADAS: string = OPCIONES_SELECT_JUSTIFICACION_PLANIFICACIONES_NO_EJECUTADAS[0];

    const defaultState: stateCardSolicitudes = {
        solicitudesReintegro: [],
        fechaDesde: props.solicitudPlanificada !== undefined ? new Date(props.solicitudPlanificada.fechaInicio) : null,
        fechaHasta: props.solicitudPlanificada !== undefined ? new Date(props.solicitudPlanificada.fechaFin) : null,
        loadingCreacion: false
    }

    const defaultStateModal: stateModal = {
        solicitud: undefined,
        showModal: false,
        content: undefined
    }

    const defaultStateModalFormulario: stateModalFormulario = {
        url: "",
        loadingFormulario: false,
        tituloModal: 'Solicitud de Vacaciones',
        content: undefined
    }

    const defaultStateModalVistaPrevia: stateModalVistaPrevia = {
        loadingContenido: false,
        url: "",
        tituloModal: "Solicitud Vacaciones",
    }

    const defaultStateModalAnularSolicitud: stateModalAnularSolicitudAprobada = {
        cargando: false,
        content: undefined,
        idSolicitudVacaciones: -1,
        mensajeBody: "",
        tituloModal: "",
        solicitudVacacionesAsociada: undefined
    }

    const defaultSolicitudVacaciones: SolicitudVacaciones = {
        fechaSolicitud : new Date().toString(),
        idSolicitud: -1,
        diasOrdinarios: -1,
        estado: -1,
        estadoParse: "",
        fechaFin: new Date(),
        fechaFinString: "",
        fechaInicio: new Date(),
        fechaInicioString: "",
        idPersona: -1,
        nuevas: false,
        reintegro: false,
        permiso: false,
        horadesde: "",
        horahasta: "",
        totalhoras: "",
        esxresolucion: "",
        nrodocautorizacion : ""
    }


    const defaultStateModalReintegro: stateModalSolicitarReintegro = {
        content: undefined,
        solicitudVacaciones: defaultSolicitudVacaciones,
    }


    const defaultStateModalAnulacionReintegro: stateModalAnulacionReintegro = {
        content: undefined,
        showModal: false,

    }


    const defaultStateModalAnulacionReplanificacion: stateModalAnulaSolicitudReplanificacion = {
        content: undefined,
        showModal: false,
        idSolicitud: -1
    }







    const [stateCard, setstateCard] = useState<stateCardSolicitudes>(defaultState)
    const [loadingDetalleDiasSolicitud, setloadingDetalleDiasSolicitud] = useState<boolean>(false)
    const [detalleDiasSolicitudVacacion, setdetalleDiasSolicitudVacacion] = useState<DetalleDiasVacacionesSolicitados|undefined>(undefined)


    //States para componente Card Padre

    const [tabActiva, settabActiva] = useState<TabSolicitudActiva>(TabSolicitudActiva.VACACIONES_PLANIFICADAS)
    const [subtabActiva, setsubtabActiva] = useState<TabSolicitudActiva>(TabSolicitudActiva.PERMISOS_IMPUTABLES_DIAS)




    //Fechas A Excluir 
    const [fechasEscogidas, setfechasEscogidas] = useState<Date[]>([])


    const [saldoDias, setsaldoDias] = useState<number>(props.diasPendientes)
    const [diasPendientes, setdiasPendientes] = useState<number>(props.diasPendientes)
    const [mensajeError, setmensajeError] = useState<string>("")
    const [stateModal, setstateModal] = useState<stateModal>(defaultStateModal);

    const [stateModalFormulario, setstateModalFormulario] = useState<stateModalFormulario>(defaultStateModalFormulario)
    const [stateModalVistaPrevia, setStateModalVistaPrevia] = useState<stateModalVistaPrevia>(defaultStateModalVistaPrevia)
    const [stateModalAnularSolicitudAprobada, setstateModalAnularSolicitudAprobada] = useState(defaultStateModalAnularSolicitud)
    //Reintegro
    const [stateModalSolicitarReintegro, setstateModalSolicitarReintegro] = useState(defaultStateModalReintegro)
    const [stateModalAnularReintegro, setstateModalAnularReintegro] = useState(defaultStateModalAnulacionReintegro)
    //Constantes Permisos con cargo a Vacaciones
    const [permisoCargoVacaciones, setpermisoCargoVacaciones] = useState<boolean>(false)
    const [justificacionPermiso, setjustificacionPermiso] = useState<string>("")
    //Constantes de Permisos por horas
    const HORA_INICIO_PERMITIDA = props.horarioLaboral.horaEntrada
    const HORA_FIN_PERMITIDA = props.horarioLaboral.horaSalida

    const RANGO_INICIO_ALMUERZO = props.horarioAlmuerzo.horaInicio
    const RANGO_FIN_ALMUERZO = props.horarioAlmuerzo.horaFin
    const TIEMPO_ALMUERZO = props.horarioAlmuerzo.tiempo


    const HORAS_TRABAJO_POR_DIA = 8;

    const [habilitarIngresoHoras, sethabilitarIngresoHoras] = useState<boolean>(false)
    const [horaDesde, setHoraDesde] = useState<string | undefined>(HORA_INICIO_PERMITIDA)
    const [horaHasta, setHoraHasta] = useState<string | undefined>(HORA_FIN_PERMITIDA)
    const [horasSolicitadas, setHorasSolicitdas] = useState<string | undefined>(undefined)
    const [fraccionHoraDia, setfraccionHoraDia] = useState<number | undefined>(undefined)
    const [errorHoras, seterrorHoras] = useState<string>("")
    const [mensajePermisoMedico, setmensajePermisoMedico] = useState<string>("")
    const [fechaPermisoHora, setfechaPermisoHora] = useState<Date | null>(null)

    const [horarioParaPermisoHora, sethorarioParaPermisoHora] = useState<HorarioLaboralServidorPermisosHoras | undefined>(undefined)
    const [horasPermisoHoraDelDia, sethorasPermisoHoraDelDia] = useState<HoraPermisoVacaciones[]>([])

    const [loadingHorarioPermisoHora, setloadingHorarioPermisoHora] = useState<boolean>(false)

    const [horarioAlmuerzo, sethorarioAlmuerzo] = useState<boolean>(false)
    const [incluyeHoraAlmuerzo, setincluyeHoraAlmuerzo] = useState<boolean>(false)
    const [descontandoTiempoAlmuerzo, setdescontadoTiempoAlmuerzo] = useState<boolean>(false)

    const [justificacionPermisoHora, setjustificacionPermisoHora] = useState<string>("")

    //Constates Componente Justificar Planificaciones No Ejecutadas
    const [mostrarcomponentePlanificacionesNoEjec, setmostrarcomponentePlanificacionesNoEjec] = useState<boolean>(false)
    const [justificacionPlanificacionNoEjec, setjustificacionPlanificacionNoEjec] = useState<string>("")
    //Replanificacion
    const [stateModalAnularSolicitudReplanificacion, setstateModalAnularSolicitudReplanificacion] = useState<stateModalAnulaSolicitudReplanificacion>(defaultStateModalAnulacionReplanificacion)

    //Hooks del contexto de solicitudVacaciones
    const { setbloquearChecks, setmostrarModalReplanificacion, mostrarModalReplanificacion } = useSolicitudVacacionesContext();



    useEffect(() => {
        setdiasPendientes(props.diasPendientes)
        setsaldoDias(props.diasPendientes)
    }, [props.diasPendientes])

    useEffect(() => {
        if (props.solicitudPlanificada !== undefined) {
            const { fechaInicio, fechaFin, } = props.solicitudPlanificada;
            setstateCard({ ...stateCard, fechaDesde: new Date(fechaInicio), fechaHasta: new Date(fechaFin), })
        }
        else {
            setstateCard({ ...stateCard, fechaDesde: null, fechaHasta: null, })

        }
    }, [props.solicitudPlanificada])


    useEffect(() => {
        // if (props.solicitudPlanificada !== undefined && stateCard.fechaDesde !== null &&  stateCard.fechaHasta !== null 
        //     && (
        //     new Date(props.solicitudPlanificada.fechaInicio).getTime() !== new Date(stateCard.fechaDesde).getTime() || new Date(props.solicitudPlanificada.fechaFin).getTime() !== new Date(stateCard.fechaHasta).getTime()
        //     )
        // ) {            
        //     props.onChangeFechaConPlanificacion(stateCard.fechaDesde, stateCard.fechaHasta);
        // }

        if (props.solicitudPlanificada !== undefined) {
            props.onChangeFechaConPlanificacion(stateCard.fechaDesde, stateCard.fechaHasta);
        }

    }, [stateCard, props.onChangeFechaConPlanificacion])

    const limpiarFechasCardYModal = useCallback(
        () => {

            setstateCard({ ...stateCard, fechaDesde: null, fechaHasta: null })
            setstateModalFormulario(defaultStateModalFormulario)
        },
        [stateModalFormulario, stateCard, saldoDias, props.planificacionesNoEjecutadas],
    )
    const handleClickSolicitar = useCallback(
        async () => {

            const diferenciaSeleccionada = GetDiferenciaSeleccion();
            if (saldoDias < 0) {
                setmensajeError("La cantidad escogida excede sus días pendientes")

                return
            }
            else if (+diferenciaSeleccionada > 44) {
                setmensajeError("No puede realizar una solicitud de vacaciones que supere los 44 días ordinarios")

                return
            }
            var respuestaSolicitud: ResponseRequest = { status: -1 };

            const { fechaDesde, fechaHasta } = stateCard
            setstateCard({ ...stateCard, loadingCreacion: true })

            const condicionPermisoPorHoras = habilitarIngresoHoras && fraccionHoraDia !== undefined && fraccionHoraDia < 1;






            if (fechaDesde && fechaHasta && typeof (fechaDesde) !== "string" && typeof (fechaHasta) !== "string" && !condicionPermisoPorHoras) {

                if (overlaps_dates(fechaDesde, fechaHasta, fechasEscogidas)) {
                    setmensajeError("Debe escoger un rango de fechas que no interfiera con sus solicitudes de vacaciones o sus fechas de licencia")
                    setstateCard({ ...stateCard, loadingCreacion: false })
                    return
                }

                const listadoIdPlanificacionesNoEjecutadas = ObtenerListadoIdPlanificacionesNoEjecutadas(props.planificacionesNoEjecutadas)





                const solicitudNueva: SolicitudVacacionesPost = {
                    FechaInicio: PruebaSolucion2(fechaDesde),
                    FechaFin: PruebaSolucion2(fechaHasta),
                    justificacion: justificacionPermiso,
                    ListadoPlanificacionesNoEjecutadas: listadoIdPlanificacionesNoEjecutadas,
                    JustificacionPlanificacionesNoEjecutadas: justificacionPlanificacionNoEjec,
                    PermisoPorHora: false,
                    PermisoPorDia: permisoCargoVacaciones,
                    PermisoHoraIncluyeAlmuerzo: incluyeHoraAlmuerzo || descontandoTiempoAlmuerzo,
                    NroDiasOrdinarios: +diferenciaSeleccionada
                }

                respuestaSolicitud = await SolicitarVacacionesFormulario(solicitudNueva, props.acuerdoMediosElectronicos);

            }
            else if (condicionPermisoPorHoras && fechaPermisoHora !== null && horaDesde !== undefined && horaHasta !== undefined && justificacionPermisoHora !== "") {
                const fechaDesdeConHoras = AgregarHoraAFecha(fechaPermisoHora, horaDesde)
                const fechaHastaConHoras = AgregarHoraAFecha(fechaPermisoHora, horaHasta)
                const listadoIdPlanificacionesNoEjecutadas = ObtenerListadoIdPlanificacionesNoEjecutadas(props.planificacionesNoEjecutadas)

                const solicitudNueva: SolicitudVacacionesPost = {
                    FechaInicio: PruebaSolucion2(fechaDesdeConHoras),
                    FechaFin: PruebaSolucion2(fechaHastaConHoras),
                    justificacion: justificacionPermisoHora,
                    ListadoPlanificacionesNoEjecutadas: listadoIdPlanificacionesNoEjecutadas,
                    JustificacionPlanificacionesNoEjecutadas: justificacionPlanificacionNoEjec,
                    PermisoPorHora: true,
                    PermisoPorDia: permisoCargoVacaciones,
                    PermisoHoraIncluyeAlmuerzo: incluyeHoraAlmuerzo || descontandoTiempoAlmuerzo,
                    NroDiasOrdinarios: 0

                }
                respuestaSolicitud = await SolicitarVacacionesFormulario(solicitudNueva, props.acuerdoMediosElectronicos);

            }


            if (respuestaSolicitud.status === 200) {


                var content: any = undefined;

                if (!props.acuerdoMediosElectronicos) {
                    content = (
                        <AlertNew
                            mensaje={MENSAJE_ADVERTENCIA_USO_MEDIOS_ELECTRONICOS}
                            oncloseElement={() => ""}
                            closeButton={false}

                        />
                    )
                }

                setstateCard({ ...stateCard, loadingCreacion: false })
                if (permisoCargoVacaciones) {
                    setstateModalFormulario({ url: respuestaSolicitud.dataResponse, loadingFormulario: false, tituloModal: "Solicitud de Permiso Imputable a vacaciones", content })
                }
                else {
                    setstateModalFormulario({ url: respuestaSolicitud.dataResponse, loadingFormulario: false, tituloModal: "Solicitud de Vacaciones", content })
                }





                // setdiasPendientes(saldoDias)


                // ;
            }
            else {
                // alertService.error(respuestaSolicitud.errorMessage ?? "");

                showAlertSwal(respuestaSolicitud.errorMessage ?? "",false);

                setstateCard({ ...stateCard, loadingCreacion: false })

            }

            ScrollToTop();
        }, [stateCard, saldoDias, diasPendientes, justificacionPermiso, permisoCargoVacaciones, fechasEscogidas, props.acuerdoMediosElectronicos, justificacionPlanificacionNoEjec, mostrarcomponentePlanificacionesNoEjec, props.planificacionesNoEjecutadas,
        fraccionHoraDia, habilitarIngresoHoras, fechaPermisoHora, horaDesde, horaHasta, justificacionPermisoHora, incluyeHoraAlmuerzo, descontandoTiempoAlmuerzo
    ]
    )




    useEffect(() => {
        const { fechaDesde, fechaHasta } = stateCard;
        const { planificaciones, planificacionesNoEjecutadas } = props;
        var solicitaPermiso: boolean = false;
        var debeJustificarPlanificacionNoEjecutada: boolean = false;
        // const esCodigoTrabajo: boolean = VerificarServidorSoloTieneCodigoTrabajo(props.idRegimenLaboral);

        const fechaHoraActual = new Date();
        const fechaActual = new Date(fechaHoraActual.getFullYear(), fechaHoraActual.getMonth(), fechaHoraActual.getDate(), 0, 0, 0);
        if (fechaDesde !== undefined && fechaHasta !== undefined && fechaDesde !== null && fechaHasta !== null) {
            var excedeDiasPendientes: boolean = false;
            const fechaDesdeParse = new Date(fechaDesde);
            const fechaHastaParse = new Date(fechaHasta);

            // const planificoVacaciones: boolean = planificaciones.find((c => {
            //     const fip = new Date(c.fechaInicio)
            //     const ffp = new Date(c.fechaFin)
            //     return fip.getTime() === fechaDesdeParse.getTime() && ffp.getTime() === fechaHastaParse.getTime()
            // })) !== undefined

            // solicitaPermiso = !planificoVacaciones


            const diferenciaFechasSeleccionadas = function_calcular_dias_ordinarios(fechaDesdeParse, fechaHastaParse);

            excedeDiasPendientes = diferenciaFechasSeleccionadas > diasPendientes;

            if (!excedeDiasPendientes) {
                setmensajeError("")
            }

            if (diferenciaFechasSeleccionadas <= props.nroMaximoDiasOrdinariosImputablesVacaciones && planificaciones.length >= 0) {

                const planificoVacaciones: boolean = planificaciones.find((c => {
                    const fip = new Date(c.fechaInicio)
                    const ffp = new Date(c.fechaFin)
                    return fip.getTime() === fechaDesdeParse.getTime() && ffp.getTime() === fechaHastaParse.getTime() && fechaActual.getTime() < fechaDesdeParse.getTime()
                })) !== undefined

                solicitaPermiso = !planificoVacaciones &&   (diferenciaFechasSeleccionadas <= 3) && !excedeDiasPendientes;

            }


            debeJustificarPlanificacionNoEjecutada = planificacionesNoEjecutadas.length > 0 && !excedeDiasPendientes;






        }

        //Validando Permisos Por horas
        const tienePermisoPorHoras = fechaPermisoHora !== null && horaDesde !== undefined && horaHasta !== undefined && fraccionHoraDia !== undefined && fraccionHoraDia < 1 && fraccionHoraDia <= diasPendientes
        debeJustificarPlanificacionNoEjecutada = debeJustificarPlanificacionNoEjecutada || (tienePermisoPorHoras && planificacionesNoEjecutadas.length > 0)


        //Esto es para indicar que a parte de las condiciones de un Permiso, el servidor especificamente selecciono la pestaña de permiso por dias.
        solicitaPermiso = solicitaPermiso && subtabActiva === TabSolicitudActiva.PERMISOS_IMPUTABLES_DIAS;



        setpermisoCargoVacaciones(solicitaPermiso);
        if (solicitaPermiso) {
            setjustificacionPermiso(DEFAULT_JUSTIFICACION_PERMISO)
        } else {
            setjustificacionPermiso("")
        }

        setmostrarcomponentePlanificacionesNoEjec(debeJustificarPlanificacionNoEjecutada);
        if (debeJustificarPlanificacionNoEjecutada) {
            setjustificacionPlanificacionNoEjec(DEFAULT_JUSTIFICACION_PLANIFICACIONES_NO_EJECUTADAS)
        } else {
            setjustificacionPlanificacionNoEjec("")
        }

    }, [stateCard.fechaDesde, stateCard.fechaHasta, props.planificaciones, props.planificacionesNoEjecutadas, diasPendientes, fechaPermisoHora, horaDesde, horaHasta, fraccionHoraDia, subtabActiva])





    const GetDiferenciaSeleccion = useCallback(
        () => {
            const { fechaDesde, fechaHasta } = stateCard;
            
            // if (fechaDesde && typeof (fechaDesde) !== "string" && fechaHasta && typeof (fechaHasta) !== "string") {
            //     return function_calcular_dias_ordinarios(fechaDesde, fechaHasta)
            // }
            if (fechaDesde && typeof (fechaDesde) !== "string" && fechaHasta && typeof (fechaHasta) !== "string" && detalleDiasSolicitudVacacion !== undefined)  {
                if(detalleDiasSolicitudVacacion.ajusteDias){
                    return detalleDiasSolicitudVacacion.valorDiasAjustados
                }else{
                    return function_calcular_dias_ordinarios(fechaDesde, fechaHasta)
                }
            }
            else {
                return "";
            }

        }, [stateCard.fechaDesde, stateCard.fechaHasta, detalleDiasSolicitudVacacion,diasPendientes, saldoDias])


    useEffect(() => {
      
        
        const fechaDesdeSolicitud = stateCard.fechaDesde
        const fechaHastaSolicitud = stateCard.fechaHasta

      if( fechaDesdeSolicitud && fechaHastaSolicitud){

        const ConsultarDetalleDiasSolicitudVacacion = async() => {
            const fechaDesdeRequest = new Date(fechaDesdeSolicitud)
            const fechaHastaRequest = new Date(fechaHastaSolicitud)









            setloadingDetalleDiasSolicitud(true)
            const respuestaDetalleDias = await ObtenerDetalleDiasSolicitarVacaciones(fechaDesdeRequest,fechaHastaRequest);

            if(respuestaDetalleDias.status === 200 && respuestaDetalleDias.dataResponse){
                setdetalleDiasSolicitudVacacion(respuestaDetalleDias.dataResponse); 
                if(respuestaDetalleDias.dataResponse.ajusteDias){

                    // const mensajeAjusteDias:string = `Debido a un cambio en su horario laboral, su solicitud de ${respuestaDetalleDias.dataResponse.valorDiasSolicitados} 
                    // días, ahora será de ${respuestaDetalleDias.dataResponse.valorDiasAjustados} días.
                    // ` 

                    const mensajeAjusteDias:string = `Ud. está solicitando vacaciones en el periodo de recuperación de la jornada de trabajo del 18 de agosto,
                    en el cual, cada día equivale a 9 horas de trabajo por día; por lo tanto, su solicitud de ${respuestaDetalleDias.dataResponse.valorDiasSolicitados}
                    días, equivale a ${respuestaDetalleDias.dataResponse.valorDiasAjustados} días ordinarios.
                    ` 
                    
                    
                    
                    showAlertSwalAnuncio(mensajeAjusteDias)
                   
                }
            }
            else{
                const mensajeDefault = "No ha sido posible obtener el detalle de los días solicitados"
                showAlertSwal(respuestaDetalleDias.errorMessage??mensajeDefault,false)
            }
            setloadingDetalleDiasSolicitud(false)
        };



        
            const fechaParseDesde = new Date(fechaDesdeSolicitud)
            const fechaParseHasta =  new Date(fechaHastaSolicitud);
            const listadoFechas = obtener_rango_fechas_no_weekend(fechaParseDesde,fechaParseHasta)
            const diferenciaDias = function_calcular_dias_ordinarios(fechaParseDesde,fechaParseHasta)
            const hoy = new Date();
            const fechaHoyNoTime = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());


            const incluyeFechaHoy = listadoFechas.find((v) => v.getTime() === fechaHoyNoTime.getTime() ) !== undefined
            if(diferenciaDias > 3 && incluyeFechaHoy){
                setmensajeError("Si desea incluir el día de hoy dentro del rango de fechas de su permiso, este no puede ser mayor a 3 días.")
            }     
        
            ConsultarDetalleDiasSolicitudVacacion();
         
      }


    }, [stateCard.fechaDesde,stateCard.fechaHasta])
    



    const handleClickAnular = (solicitud: SolicitudVacaciones) => {
        const content: any = GetHTMLSolicitudVacacionesIngresadas([solicitud], false)
        setstateModal({
            showModal: true,
            solicitud,
            content
        });
    }
    const handleClickAnularReintegro = (solicitud: SolicitudReintegroVacaciones) => {
        const content: any = GetHTMLSolicitudReintegroIngresadas([solicitud], false)
        setstateModalAnularReintegro({
            showModal: true,
            solicitud,
            content
        });
    }

    const handleClickSolicitarReintegro = async (solicitud: SolicitudVacaciones) => {


        const content: any = GetHTMLSolicitudVacacionesIngresadas([solicitud], false)



        setstateModalSolicitarReintegro({
            content,
            solicitudVacaciones: solicitud,
        });
    }


    const handleClickAnularSolicitudAprobada = (solicitud: SolicitudVacaciones) => {
        const content: any = GetHTMLSolicitudVacacionesIngresadas([solicitud], false)

        if (!solicitud.permiso) {
            setstateModalAnularSolicitudAprobada({
                cargando: false,
                content,
                idSolicitudVacaciones: solicitud.idSolicitud ?? -1,
                mensajeBody: "¿Está seguro/a que desea anular la solicitud de vacaciones que ya ha sido aprobada?",
                tituloModal: "Anular Solicitud de Vacaciones",
                solicitudVacacionesAsociada: solicitud
            })
        }
        else {
            setstateModalAnularSolicitudAprobada({
                cargando: false,
                content,
                idSolicitudVacaciones: solicitud.idSolicitud ?? -1,
                mensajeBody: "¿Está seguro/a que desea anular la solicitud de permiso imputable a vacaciones que ya ha sido aprobada?",
                tituloModal: "Anular Solicitud de Permiso Imputable a Vacaciones",
                solicitudVacacionesAsociada: solicitud
            })
        }


    }

    const handleClickAnularSolicitudAnulacion = (solicitud: SolicitudVacaciones) => {
        handleClickAnular(solicitud);
    }

    const handleClickAnularSolicitudReintegro = (solicitud: SolicitudReintegroVacaciones) => {
        handleClickAnularReintegro(solicitud);
    }



    const handleClickAnularSolicitudReplanificacionVacaciones = (solicitud: SolicitudReplanificacionVacaciones) => {
        const content: any = GetHtmlSolicitudReplanificacionVacacionesIngresada(solicitud, false)
        setstateModalAnularSolicitudReplanificacion({
            showModal: true,
            content,
            idSolicitud: solicitud.idSolicitudReplanificacion
        });
    }



    async function handleClickVerSolicitud(solicitud: SolicitudVacaciones) {
        setStateModalVistaPrevia({ ...stateModalVistaPrevia, loadingContenido: true })
        const responseSolicitudDocumento: ResponseRequest = await ObtenerVistaPreviaDocumentoSolicitudVacaciones(solicitud.idSolicitud ?? -1);
        if (responseSolicitudDocumento.status !== 200) {
            alertService.error(responseSolicitudDocumento.errorMessage ?? "Ha ocurrido un inconveniente al tratar de obtener el documento de la solicitud de vacaciones")
            setStateModalVistaPrevia({ ...stateModalVistaPrevia, loadingContenido: false })
            return
        }
        const blob_resource = await responseSolicitudDocumento.dataResponse;
        let url = window.URL.createObjectURL(blob_resource);
        const tituloDocumento = solicitud.permiso ? "Permiso Cargo Vacaciones" : "Solicitud de Vacaciones";

        setStateModalVistaPrevia({ url, loadingContenido: false, tituloModal: tituloDocumento })
    }

    async function handleClickVerSolicitudReintegro(solicitud: SolicitudReintegroVacaciones) {
        setStateModalVistaPrevia({ ...stateModalVistaPrevia, loadingContenido: true })
        const responseSolicitudDocumento: ResponseRequest = await ObtenerVistaPreviaDocumentoSolicitudReintegroVacaciones(solicitud.idSolicitudReintegro ?? -1);
        if (responseSolicitudDocumento.status !== 200) {
            alertService.error(responseSolicitudDocumento.errorMessage ?? "Ha ocurrido un inconveniente al tratar de obtener el documento de la solicitud de reintegro de vacaciones")
            setStateModalVistaPrevia({ ...stateModalVistaPrevia, loadingContenido: false })
            return
        }
        const blob_resource = await responseSolicitudDocumento.dataResponse;
        let url = window.URL.createObjectURL(blob_resource);
        const tituloDocumento = "Solicitud de Reintegro de Vacaciones";

        setStateModalVistaPrevia({ url, loadingContenido: false, tituloModal: tituloDocumento })
    }

    async function handleClickVerSolicitudReplanificacionVacaciones(solicitud: SolicitudReplanificacionVacaciones) {
        setStateModalVistaPrevia({ ...stateModalVistaPrevia, loadingContenido: true })
        const responseSolicitudDocumento: ResponseRequest = await ObtenerVistaPreviaDocumentoSolicitudReplanificacion(solicitud.idSolicitudReplanificacion);
        if (responseSolicitudDocumento.status !== 200) {
            alertService.error(responseSolicitudDocumento.errorMessage ?? "Ha ocurrido un inconveniente al tratar de obtener el documento de la solicitud de replanificación y/o justificación de vacaciones")
            setStateModalVistaPrevia({ ...stateModalVistaPrevia, loadingContenido: false })
            return
        }
        const blob_resource = await responseSolicitudDocumento.dataResponse;
        let url = window.URL.createObjectURL(blob_resource);
        const tituloDocumento = "Solicitud de Reprogramación y/o Justificación de Vacaciones";

        setStateModalVistaPrevia({ url, loadingContenido: false, tituloModal: tituloDocumento })
    }

    async function AnularSolicitud(idSolicitud: number) {
        const statusAnulacion = await AnularSolicitudVacaciones(idSolicitud);
        if (statusAnulacion === 1) {
            alertService.success("La solicitud ha sido anulada con éxito");
        }
        else {
            alertService.error("Ha ocurrido un inconveniente al intentar anular la solicitud");
        }
        return statusAnulacion;
    }

    async function AnularSolicitudReintegro(idSolicitud: number) {
        const statusAnulacion = await AnularSolicitudReintegroVacaciones(idSolicitud);
        if (statusAnulacion === 1) {
            alertService.success("La solicitud ha sido anulada con éxito");
        }
        else {
            alertService.error("Ha ocurrido un inconveniente al intentar anular la solicitud");
        }
        return statusAnulacion;
    }

    async function AnularSolicitudReplanificacion(idSolicitud: number) {
        const statusAnulacion = await AnularSolicitudReplanificacionVacaciones(idSolicitud);
        if (statusAnulacion === 1) {
            alertService.success("La solicitud ha sido eliminada con éxito");
        }
        else {
            alertService.error("Ha ocurrido un inconveniente al intentar eliminar la solicitud");
        }
        return statusAnulacion;
    }

    async function AnularSolicitudAprobada(idSolicitud: number, observacion: string, listadoReplanificacion: Replanificacion[]) {

        const solicitud: SolicitudVacacionesAnulacionPost = {
            IdSolicitudVacaciones: idSolicitud,
            MotivoAnulacion: observacion,
            ListadoReplanificacion: listadoReplanificacion
        }
        const respuesta = await AnularSolicitudVacacionesAprobada(solicitud)
        if (respuesta.status !== 200) {
            alertService.error(respuesta.errorMessage)
            return -1
        }
        else {
            alertService.success("Se ha creado la solicitud de anulación de vacaciones");
            return 1
        }
    }


    async function SolicitarReintegro(idSolicitud: number, observacion: string, fechaReintegro: Date, listadoReplanificacion: Replanificacion[]) {

        const solicitud: SolicitudReintegroVacacionesPost = {
            IdSolicitudVacaciones: idSolicitud,
            MotivoReintegro: observacion,
            FechaReintegro: fechaReintegro,
            ListadoReplanificacion: listadoReplanificacion
        }

        const respuesta = await SolicitarReintegroVacaciones(solicitud);
        if (respuesta.status !== 200) {
            alertService.error(respuesta.errorMessage)
            return -1
        }
        else {
            const esPermiso = respuesta.dataResponse?.esPermiso;
            // const mensajeExito = `Se ha creado la solicitud de reintegro de vacaciones.${!esPermiso ? " Recuerde reprogramar los días de vacaciones no gozadas." : ""}`;
            const mensajeExito = `Se ha creado la solicitud de reintegro de vacaciones.`;
            alertService.success(mensajeExito);
            return 1
        }
    }






    useEffect(() => {
        var nuevasFechasEscogidas: Date[] = []


        if (props.solicitudes.length > 0) {
            const feriados = props.feriados.map((val, ind) => {
                return new Date(val)
            })
            props.solicitudes.map((val, ind) => {
                const { fechaInicio, fechaFin } = val;
                var rangoFechasExcluir = [...obtener_rango_fechas_no_weekend(fechaInicio, fechaFin)]
                const solicitudReintegro = props.solicitudesReintegro.find((v) => v.idSolicitudVacaciones === val.idSolicitud);
                const tieneReintegro = solicitudReintegro !== undefined;
                if (solicitudReintegro !== undefined) {
                    var fechahastareintegro = GetNPreviousLaboralDay(new Date(solicitudReintegro.fechaReintegro), feriados, 1);
                    rangoFechasExcluir = [...obtener_rango_fechas_no_weekend(fechaInicio, fechahastareintegro)]
                }
                nuevasFechasEscogidas = [...nuevasFechasEscogidas, ...rangoFechasExcluir]

            })
        }
        if (props.fechasLicencia.length > 0) {

            props.fechasLicencia.map((val, ind) => {
                const { fechadesde, fechahasta } = val;
                nuevasFechasEscogidas = [...nuevasFechasEscogidas, ...obtener_rango_fechas_no_weekend(fechadesde, fechahasta)]
            })

        }



        setfechasEscogidas(nuevasFechasEscogidas)
        setstateModal(defaultStateModal);
        //setstateModalFormulario(defaultStateModalFormulario)
    }, [props.solicitudes, props.fechasLicencia, props.solicitudesReintegro])






    const DatePickerInicio = useCallback((permiso: boolean) => {
        const feriados = props.feriados.map((val, ind) => {
            return new Date(val)
        })





        var excludeDates = [...fechasEscogidas, ...feriados];

        if (props.fechasPermisosMedicos.length > 0) {
            
            for (let index = 0; index < props.fechasPermisosMedicos.length; index++) {
                const elemento = props.fechasPermisosMedicos[index];
                const fechaDesde = elemento.fechaDesde;
                const fechaHasta = elemento.fechaHasta;
                // if (!elemento.permitirEnDias || elemento.permitirEnHoras) {

                //El 29/08/2024 se realizo este cambio, segun lo conversado con MSC Ruth Alvarez, si el servidor tiene 
                //permiso de horas en las fechas indicada, el usuario puede pedir permiso de dia y se le descuenta el dia completo
                // no se lo restringe
                if (!elemento.permitirEnDias) {

                    excludeDates = [...excludeDates, ...obtener_rango_fechas_no_weekend(fechaDesde, fechaHasta)]
                }


            }

            // props.fechasPermisosMedicos.map((val, ind) => {
            //     const { fechaDesde, fechaHasta } = val;
            //     excludeDates = [...excludeDates, ...obtener_rango_fechas_no_weekend(fechaDesde, fechaHasta)]
            // })

        }


        var fechaMinima = new Date();

        fechaMinima = GetNPreviousLaboralDay(fechaMinima, feriados,2);


        const fecha3MesesDespues = SumarMesesFecha(new Date(), 3);

        var fechaMaxima = fecha3MesesDespues

        if(props.fechafincontrato !== null){
           fechaMaxima = new Date(props.fechafincontrato)
        }



        return (
            <Datepicker
                value={stateCard.fechaDesde}
                disabled={!permiso}
                name="fechadesde"
                id="fechadesde"
                onChange={(e) => { setstateCard({ ...stateCard, fechaDesde: e, fechaHasta: null }) }}
                min={fechaMinima}
                max={fechaMaxima}
                filter={(date: Date) => isWeekday(date)}
                showDisabledMonthNavigation={true}
                excludeDates={excludeDates}
                dayClassName={(date: Date) => isFeriado(date, props.feriados)}
            />
        )
    }, [stateCard.fechaDesde, stateCard.fechaHasta, fechasEscogidas, props.feriados])

    // }, [stateCard.fechaDesde, stateCard.fechaHasta, stateCard.fechasEscogidas, props.feriados, props.anioSolicitud, props.fechasLicencia])





    const DatePickerFin = useCallback((permiso: boolean) => {
        const feriados = props.feriados.map((val, ind) => {
            return new Date(val)
        })
        var excludeDates = [...fechasEscogidas, ...feriados];

        // if (props.fechasPermisosMedicos.length > 0) {

        //     props.fechasPermisosMedicos.map((val, ind) => {
        //         const { fechaDesde, fechaHasta } = val;
        //         excludeDates = [...excludeDates, ...obtener_rango_fechas_no_weekend(fechaDesde, fechaHasta)]
        //     })

        // }

        if (props.fechasPermisosMedicos.length > 0) {

            for (let index = 0; index < props.fechasPermisosMedicos.length; index++) {
                const elemento = props.fechasPermisosMedicos[index];
                const fechaDesde = elemento.fechaDesde;
                const fechaHasta = elemento.fechaHasta;
                if (!elemento.permitirEnDias) {
                    excludeDates = [...excludeDates, ...obtener_rango_fechas_no_weekend(fechaDesde, fechaHasta)]
                }


            }
        }

        const fechaminima = stateCard.fechaDesde ?? SumarDiasFecha(new Date(), -7)

        const fechaCon3Meses = SumarMesesFecha(new Date(), 3);
        const fechaUltimoDiaAnio = new Date(props.anioSolicitud, 11, 31);

        const fechaHoy = new Date();
        const fechaHoyNoTime = new Date(fechaHoy.getFullYear(),fechaHoy.getMonth(),fechaHoy.getDate(),0,0,0);

        var fechaMaxima = fechaCon3Meses

        if(props.fechafincontrato !== null){
            fechaMaxima = new Date(props.fechafincontrato)
         }

        if(permiso && stateCard.fechaDesde){
            const inicio = new Date(stateCard.fechaDesde);
            if(inicio.getTime()  <= fechaHoyNoTime.getTime() ){
                fechaMaxima = SumarDiasLaboralesFecha(inicio,2,feriados)
            }
        }


        return (
            <Datepicker
                value={stateCard.fechaHasta}
                disabled={!permiso}
                name="fechahasta"
                id="fechahasta"
                onChange={(e) => {
                    setstateCard({ ...stateCard, fechaHasta: e })
                }}
                min={fechaminima}
                max={fechaMaxima}
                filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, props.feriados)}
                showDisabledMonthNavigation={true}
                excludeDates={excludeDates}
                dayClassName={(date: Date) => isFeriado(date, props.feriados)}
            />
        )
    }, [stateCard.fechaHasta, stateCard.fechaDesde, fechasEscogidas, props.feriados, props.anioSolicitud, props.fechasLicencia, diasPendientes])


    function CalcularDiasARestarPermisoHoras(fecha: Date, feriados: Date[], diasRestar: number) {

    }


    const DatePickerFechaHora = useCallback((permiso: boolean) => {

        const fechaActual = new Date();
        const feriados = props.feriados.map((val, ind) => {
            return new Date(val)
        })
        var excludeDates = [...fechasEscogidas, ...feriados];


        if (props.fechasPermisosMedicos.length > 0) {

            for (let index = 0; index < props.fechasPermisosMedicos.length; index++) {
                const elemento = props.fechasPermisosMedicos[index];
                const fechaDesde = elemento.fechaDesde;
                const fechaHasta = elemento.fechaHasta;
                if (!elemento.permitirEnHoras) {
                    excludeDates = [...excludeDates, ...obtener_rango_fechas_no_weekend(fechaDesde, fechaHasta)]
                }


            }

        }



        // const cantidadDiasDespuesSePuedeIngresar = -1;
        // const diasARestar = fechaActual.getDay() === 1 ? cantidadDiasDespuesSePuedeIngresar - 2 : fechaActual.getDay() === 0 ? cantidadDiasDespuesSePuedeIngresar - 1 : cantidadDiasDespuesSePuedeIngresar;


        // var fechaminima = stateCard.fechaDesde ?? SumarDiasFecha(new Date(), diasARestar);

        //const fechaminima = GetPreviousLaboralDay(fechaActual, feriados);

        var fechaMinima = new Date();

        fechaMinima = GetNPreviousLaboralDay(fechaMinima, feriados, 2);


        // var fechaminimaCalculoDias = new Date(new Date(fechaminima).setHours(0, 0, 0, 0));
        // while (feriados.find(c => c.getTime() == fechaminimaCalculoDias.getTime()) !== undefined) {
        //     fechaminimaCalculoDias = SumarDiasFecha(fechaminimaCalculoDias, -1)
        // }

        // fechaminima = fechaminimaCalculoDias



        const fechaCon3Meses = SumarMesesFecha(new Date(), 3);


        const fechaMaxima = fechaCon3Meses

        return (
            <Datepicker
                value={fechaPermisoHora}
                disabled={!permiso}
                name="fechahasta"
                id="fechahasta"
                onChange={(e) => setfechaPermisoHora(e)}
                min={fechaMinima}
                max={fechaMaxima}
                filter={(date: Date) => isWeekday(date) && isFeriadoFilter(date, props.feriados)}
                showDisabledMonthNavigation={true}
                excludeDates={excludeDates}
                dayClassName={(date: Date) => isFeriado(date, props.feriados)}
            />
        )
    }, [fechaPermisoHora, fechasEscogidas, props.feriados, props.anioSolicitud, props.fechasLicencia])


    useEffect(() => {
        if (fraccionHoraDia !== undefined) {
            const nuevosaldo = diasPendientes - fraccionHoraDia;

            const nuevoSaldoDosDecimales = Math.round((nuevosaldo + Number.EPSILON) * 100) / 100

            setsaldoDias(nuevoSaldoDosDecimales)
        }
        else {
            const diferenciaFecha = GetDiferenciaSeleccion();
            const valorDiferencia = typeof (diferenciaFecha) === "string" ? 0 : diferenciaFecha;
            const nuevosaldo = diasPendientes - valorDiferencia;
            const nuevoSaldoDosDecimales = Math.round((nuevosaldo + Number.EPSILON) * 100) / 100


            setsaldoDias(nuevoSaldoDosDecimales)
        }

    }, [GetDiferenciaSeleccion, fraccionHoraDia])












    function GetHTMLSolicitudVacacionesIngresadas(solicitudes: Array<SolicitudVacaciones>, incluirAcciones: boolean = true, incluirAccionesReintegro: boolean = false, mostrarSoloDisponiblesParaReintegro = false, permisos: boolean = false): any {
        var fechaActual = new Date();
        const htmlRowsSolicitudes = solicitudes.map((val, ind) => {
            var fechaDesdeSolicitud = new Date(val.fechaInicio)
            var fechaHastaSolicitud = new Date(val.fechaFin)
            const esPermisoPorHora = val.permiso && val.horadesde !== "" && val.horahasta !== "" && val.totalhoras !== "";

            const fechaDesdeTiempoAgregado = AgregarHoraAFecha(fechaDesdeSolicitud, val.horadesde)
            // const fechaDesdeTiempoAgregado = AgregarHoraAFecha(fechaDesdeSolicitud,"16:00")
            const fechaHastaTiempoAgregado = AgregarHoraAFecha(fechaHastaSolicitud, val.horahasta)

            const puedeAnularAprobadaAntesComenzar = (fechaActual.getTime() < fechaDesdeSolicitud.getTime() && !esPermisoPorHora) || (esPermisoPorHora && fechaActual.getTime() < fechaDesdeTiempoAgregado.getTime())
            // const puedeAnularAprobadaAntesComenzar = true

            const esVacacionDeResolcion = val.nrodocautorizacion && val.esxresolucion === "S";

            const cumplefechaparaanular = new Date(val.fechaSolicitud).getTime() < new Date(2026,2, 20, 0, 0, 0).getTime();

            const fila = (
                <Row key={"SolicitudesVacacionesUsuario" + ind} className="mt-2 rowSolicitarPermisos">
                    <Col md={2}>
                        <FormGroup>
                            <Label for="Tipo">
                                Tipo Solicitud
                            </Label>
                            <Input type="text" readOnly className="bold" value={val.estado === EstadoSolicitudVacaciones.REVERSOUNIDAD ? "ANULACIÓN" : val.permiso ? "PERMISO" : "VAC"}></Input>

                        </FormGroup>
                    </Col>
                    {
                        !esPermisoPorHora && (
                            <>
                                <Col md={2}>
                                    <FormGroup>
                                        <Label for="desdeSolicitud">
                                            Desde
                                        </Label>
                                        <Input type="text" disabled value={ObtenerFechaFromIsoFormat(val.fechaInicio.toString())}></Input>

                                    </FormGroup>
                                </Col>
                                <Col md={2}>
                                    <FormGroup>
                                        <Label for="hastaSolicitud">
                                            Hasta
                                        </Label>
                                        <Input type="text" disabled value={ObtenerFechaFromIsoFormat(val.fechaFin.toString())}></Input>
                                    </FormGroup>
                                </Col>
                                <Col md={incluirAcciones ? 2 : 3}>
                                    <FormGroup>
                                        <Label for="diasTomados">
                                            {val.estadoParse === "Aprobada/Gozada" ? "Días tomados" : "Días solicitados"}
                                        </Label>
                                        <Input type="text" value={val.diasOrdinarios} readOnly id="diasTomadosSolicitud"></Input>
                                    </FormGroup>
                                </Col>
                            </>

                        )
                    }
                    {
                        esPermisoPorHora && (
                            <>
                                <Col md={2}>
                                    <FormGroup>
                                        <Label for="desdeSolicitud">
                                            Fecha
                                        </Label>
                                        <Input type="text" disabled value={ObtenerFechaFromIsoFormat(val.fechaInicio.toString())}></Input>

                                    </FormGroup>
                                </Col>
                                <Col md={incluirAcciones ? 2 : 2}>
                                    <FormGroup>
                                        <Label for="horadesdeSolicitud">
                                            Hora Desde
                                        </Label>
                                        <Input type="text" disabled value={ParseHorasFormato(val.horadesde)}></Input>
                                    </FormGroup>
                                </Col>
                                <Col md={incluirAcciones ? 2 : 2}>
                                    <FormGroup>
                                        <Label for="horahastaSolicitud">
                                            Hora Hasta
                                        </Label>
                                        <Input type="text" disabled value={ParseHorasFormato(val.horahasta)}></Input>
                                    </FormGroup>
                                </Col>
                                <Col md={incluirAcciones ? 2 : 2}>
                                    <FormGroup>
                                        <Label for="horahastaSolicitud">
                                            Horas solicitadas
                                        </Label>
                                        <Input type="text" disabled value={ParseHorasFormato(val.totalhoras)}></Input>
                                    </FormGroup>
                                </Col>
                            </>
                        )
                    }


                    <Col md={incluirAcciones ? 2 : esPermisoPorHora ? 2 : 3}>
                        <FormGroup>
                            <Label for="estadoSolicitud">
                                Estado
                            </Label>
                            <Input type="text" value={val.estadoParse} className={val.estado === EstadoSolicitudVacaciones.APROBACIONRRHH ? "fontSizeEstadoTH" : ""} readOnly id="estadoSolicitud"></Input>
                        </FormGroup>
                    </Col>
                    {
                        incluirAcciones &&
                        <Col md={2} className="d-flex ">
                            {
                                (val.estado === EstadoSolicitudVacaciones.INGRESO || val.estado === EstadoSolicitudVacaciones.INGRESOSINDOCUMENTO || val.estado === EstadoSolicitudVacaciones.APROBACIONUNIDAD || val.estado === EstadoSolicitudVacaciones.APROBACIONRRHH || val.estado === EstadoSolicitudVacaciones.APROBACIONPARCIALUNIDAD) && !esVacacionDeResolcion &&
                                <div className="align-self-center ml-2">
                                    <i className="fas fa-file-pdf opcion_eliminar_solicitud "
                                        onClick={() => handleClickVerSolicitud(val)}
                                        data-toggle="tooltip" data-placement="top" title="Vista Previa Solicitud"
                                    >

                                    </i>
                                </div>
                            }

                            {
                                (val.estado === EstadoSolicitudVacaciones.INGRESO || val.estado === EstadoSolicitudVacaciones.INGRESOSINDOCUMENTO) &&
                                <div className="align-self-center ml-2">
                                    <i className="far fa-times-circle opcion_eliminar_solicitud"
                                        onClick={() => handleClickAnular(val)}
                                        data-toggle="tooltip" data-placement="top" title="Eliminar Solicitud"
                                    >

                                    </i>
                                </div>
                            }



                            {
                                // (incluirAccionesReintegro && val.estado === EstadoSolicitudVacaciones.APROBACIONRRHH 
                                //     && fechaDesdeSolicitud.getTime() < fechaActual.getTime() && fechaActual.getTime() < fechaHastaSolicitud.getTime()
                                // ) 
                                // &&
                                // <div className="align-self-center ml-2">
                                //     <i className="fa fa-light fa-file opcion_eliminar_solicitud "
                                //         onClick={() => handleClickSolicitarReintegro(val)}
                                //         data-toggle="tooltip" data-placement="top" title="Solicitar Reintegro"
                                //     >
                                //     </i>
                                // </div>


                            }

                            {
                                    (val.estado === EstadoSolicitudVacaciones.APROBACIONRRHH || val.estado == EstadoSolicitudVacaciones.APROBACIONUNIDAD) && cumplefechaparaanular && puedeAnularAprobadaAntesComenzar && !esVacacionDeResolcion &&
                                <div className="align-self-center">
                                    <i className="far fa-times-circle opcion_eliminar_solicitud ml-2"
                                        onClick={() => handleClickAnularSolicitudAprobada(val)}
                                        data-toggle="tooltip" data-placement="top" title="Anular Solicitud Aprobada"
                                    >

                                    </i>
                                </div>
                            }

                            {/*{*/}
                            {/*        ((val.estado === EstadoSolicitudVacaciones.REVERSOUNIDAD && fechaActual.getTime() < fechaDesdeSolicitud.getTime() && !esVacacionDeResolcion)) &&*/}
                            {/*    <div className="align-self-center">*/}
                            {/*        <i className="far fa-times-circle opcion_eliminar_solicitud ml-2"*/}
                            {/*            onClick={() => handleClickAnularSolicitudAnulacion(val)}*/}
                            {/*            data-toggle="tooltip" data-placement="top" title="Eliminar Solicitud anulación"*/}
                            {/*        >*/}

                            {/*        </i>*/}
                            {/*    </div>*/}
                            {/*}*/}

                        </Col>
                    }

                </Row>
            )

            if (!val.reintegro) {
                return fila;
            }

            // if (!val.reintegro && ((permisos && val.permiso) || (!permisos && !val.permiso)) && ((mostrarSoloDisponiblesParaReintegro && val.estado === EstadoSolicitudVacaciones.APROBACIONRRHH && fechaDesdeSolicitud.getTime() < fechaActual.getTime() && fechaActual.getTime() < fechaHastaSolicitud.getTime()) || !mostrarSoloDisponiblesParaReintegro)) {

            //     return fila;
            // }


        })



        return htmlRowsSolicitudes;
    }


    function GetHTMLSolicitudReintegroIngresadas(solicitudes: Array<SolicitudReintegroVacaciones>, acciones: boolean): any {
        var fechaActual = new Date();
        const htmlRowsSolicitudes = solicitudes.map((val, ind) => {
            var fechaDesdeSolicitud = new Date(val.fechaInicio)
            var fechaHastaSolicitud = new Date(val.fechaFin)
            var fechaReintegro = new Date(val.fechaReintegro)

            const fila = (
                <Row key={"SolicitudesReintegroUsuario" + ind} className="mt-2">
                    <Col md={2}>
                        <FormGroup>
                            <Label for="Tipo">
                                Tipo Solicitud
                            </Label>
                            <Input type="text" readOnly className="bold" value={"REINTEGRO"}></Input>

                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="reintegroSolicitud">
                                Reintegro desde
                            </Label>
                            <Input type="text" disabled value={ObtenerFechaFromIsoFormat(val.fechaReintegro.toString())}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="hastaSolicitud">
                                Hasta
                            </Label>
                            <Input type="text" disabled value={ObtenerFechaFromIsoFormat(val.fechaFin.toString())}></Input>
                        </FormGroup>
                    </Col>

                    <Col md={2}>
                        <FormGroup>
                            <Label for="diasReintegro">
                                Días reintegro
                            </Label>
                            <Input type="text" value={val.diasOrdinarios} readOnly id="diasReintegro"></Input>
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="estadoSolicitud">
                                Estado
                            </Label>
                            <Input type="text" value={val.estadoParse} readOnly id="estadoSolicitud"></Input>
                        </FormGroup>
                    </Col>


                    <Col md={2} className="d-flex col-acciones-reintegro">
                        {acciones && val.estado === EstadoSolicitudReintegro.INGRESADA &&
                            <div className="align-self-center">
                                <i className="far fa-times-circle opcion_eliminar_solicitud"
                                    onClick={() => handleClickAnularSolicitudReintegro(val)}
                                    data-toggle="tooltip" data-placement="top" title="Eliminar Solicitud reintegro"
                                >

                                </i>
                            </div>
                        }


                        {
                            (acciones && (val.estado === EstadoSolicitudReintegro.INGRESADA || val.estado === EstadoSolicitudReintegro.APROBACIONDIRECTIVO || val.estado === EstadoSolicitudReintegro.APROBACIONTH)) &&
                            <div className="align-self-center ml-2">
                                <i className="fas fa-file-pdf opcion_eliminar_solicitud "
                                    onClick={() => handleClickVerSolicitudReintegro(val)}
                                    data-toggle="tooltip" data-placement="top" title="Vista Previa Solicitud"
                                >

                                </i>
                            </div>
                        }
                    </Col>




                </Row>
            )
            return fila;

        })

        return htmlRowsSolicitudes;
    }

    function GetHtmlSolicitudReplanificacionVacacionesIngresada(solicitud: SolicitudReplanificacionVacaciones | null, acciones: boolean) {
        if (solicitud === null || solicitud !== null && (solicitud.idSolicitudReintegro !== null || solicitud.idSolicitudAnulacion !== null)) {
            return undefined
        }
        else {
            return (
                <Row key={"SolicitudReplanificacionVacaciones"} className="mt-2 rowSolicitarPermisos">
                    <Col md={2}>
                        <FormGroup>
                            <Label for="Tipo">
                                Tipo Solicitud
                            </Label>
                            <Input type="text" readOnly className="bold" value={"REPROGRAMACIÓN"}></Input>

                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="fechaSolicitudReplanificacion">
                                Fecha Solicitud
                            </Label>
                            <Input type="text" disabled value={ObtenerFechaFromIsoFormat(solicitud.fechaSolicitud.toString())}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="totalDiasOrdinariosReplanificacion">
                                D. reprogramación
                            </Label>
                            <Input id="totalDiasOrdinariosReplanificacion" type="text" disabled value={solicitud.totalDiasReplanificados.toString()}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="estadoSolicitudReplanificacion">
                                Estado
                            </Label>
                            <Input type="text" value={solicitud.estadoParse} readOnly id="estadoSolicitudReplanificacion"></Input>
                        </FormGroup>
                    </Col>
                    {
                        acciones &&
                        <Col md={2} className="d-flex">
                            <div className="align-self-center">
                                <i className="fas fa-file-pdf opcion_eliminar_solicitud ml-2"
                                    onClick={() => handleClickVerSolicitudReplanificacionVacaciones(solicitud)}
                                    data-toggle="tooltip" data-placement="top" title="Vista Previa Solicitud"
                                >

                                </i>
                            </div>
                            {
                                ((solicitud.estado === EstadoSolicitudReplanificacionVacaciones.INGRESO) || (solicitud.estado === EstadoSolicitudReplanificacionVacaciones.APROBADA_PARCIALMENTE)) &&
                                <div className="align-self-center ml-2">
                                    <i className="far fa-times-circle opcion_eliminar_solicitud "
                                        onClick={() => handleClickAnularSolicitudReplanificacionVacaciones(solicitud)}
                                        data-toggle="tooltip" data-placement="top" title="Eliminar Solicitud Replanificación y/o justificación"
                                    >

                                    </i>
                                </div>
                            }


                        </Col>
                    }

                </Row>
            )
        }
    }


    const SolicitudesVacacionesPlanificadasDelUsuario = useMemo(() => {

        if (((props.solicitudes.length > 0) && props.anioSolicitud > -1) || props.solicitudReplanificacion !== null) {

            const solicitudesUnidas: Array<SolicitudVacaciones> = [...props.solicitudes]
            solicitudesUnidas.sort((s1, s2) => CompareDates(s1.fechaInicio, s2.fechaInicio))


            const htmlRowsSolicitudes = GetHTMLSolicitudVacacionesIngresadas(solicitudesUnidas, true);
            const sol = (<div>
                {htmlRowsSolicitudes}

            </div>)

            return sol;
        }

    }, [props.solicitudes, props.anioSolicitud])

    const SolicitudesPermisosDelUsuario = useMemo(() => {

        if (((props.solicitudes.length > 0) && props.anioSolicitud > -1) || props.solicitudReplanificacion !== null) {



            const solicitudesSoloPermisos = FiltrarVacacionesIngresadas(props.solicitudes, false, { incluirDias: true, incluirHoras: true });

            const solicitudesUnidas: Array<SolicitudVacaciones> = [...solicitudesSoloPermisos]
            solicitudesUnidas.sort((s1, s2) => CompareDates(s1.fechaInicio, s2.fechaInicio))


            const htmlRowsSolicitudes = GetHTMLSolicitudVacacionesIngresadas(solicitudesUnidas, true, false, false, true);
            const sol = (
                <div>
                    {
                        solicitudesUnidas.length > 0 && (
                            <>
                                <strong>Permisos solicitados</strong>
                                {htmlRowsSolicitudes}
                            </>
                        )
                    }
                </div>)

            return sol;
        }

    }, [props.solicitudes, props.anioSolicitud])



    const SolicitudesReintegro = useMemo(() => {
        if (props.solicitudesReintegro !== null) {

            //Solicitudes ingresadas
            const solicitudesVacacionesIngresadas = FiltrarVacacionesIngresadas(props.solicitudes, true);
            const solicitudesPermisosIngresados = FiltrarVacacionesIngresadas(props.solicitudes, true, { incluirDias: true, incluirHoras: false });

            const fechaCompleta = new Date();

            // 2. Usar setHours(0, 0, 0, 0) para restablecer la hora, minutos, 
            //    segundos y milisegundos a cero (medianoche).
            fechaCompleta.setHours(0, 0, 0, 0);

            var solicitudesIngresadasMostrar = solicitudesVacacionesIngresadas.filter(f => fechaCompleta.getTime() >= new Date(f.fechaInicio).getTime())
            var permisosIngresadosMostrar = solicitudesPermisosIngresados.filter(f => fechaCompleta.getTime() >= new Date(f.fechaInicio).getTime())
            const htmlRowsSolicitudesVacaciones = GetHTMLSolicitudVacacionesIngresadas(solicitudesIngresadasMostrar, true, true);
            const htmlRowsSolicitudesPermisos = GetHTMLSolicitudVacacionesIngresadas(permisosIngresadosMostrar, true, true);

            const htmlRowsSolicitudesReintegro = GetHTMLSolicitudReintegroIngresadas(props.solicitudesReintegro, true)


            var solicitudDisponibleParaReintegro: SolicitudVacaciones | undefined = undefined;

            if (solicitudesVacacionesIngresadas.length > 0) {
                solicitudDisponibleParaReintegro = solicitudesVacacionesIngresadas.find(sv => {
                    return (
                        sv.estado === (EstadoSolicitudVacaciones.APROBACIONRRHH) && EsSolicitudVacacionesVigenteParaReintegro(sv)
                    )
                })
            }
            else if (solicitudesPermisosIngresados.length > 0) {
                solicitudDisponibleParaReintegro = solicitudesPermisosIngresados.find(sv => {
                    return (
                        sv.estado === (EstadoSolicitudVacaciones.APROBACIONRRHH) && EsSolicitudVacacionesVigenteParaReintegro(sv)
                    )
                })
            }

            // (incluirAccionesReintegro && val.estado === EstadoSolicitudVacaciones.APROBACIONRRHH 
            //     && fechaDesdeSolicitud.getTime() < fechaActual.getTime() && fechaActual.getTime() < fechaHastaSolicitud.getTime()
            // ) 
            // &&
            // <div className="align-self-center ml-2">
            //     <i className="fa fa-light fa-file opcion_eliminar_solicitud "
            //         onClick={() => handleClickSolicitarReintegro(val)}
            //         data-toggle="tooltip" data-placement="top" title="Solicitar Reintegro"
            //     >
            //     </i>
            // </div>

            var botonSolicitarReintegro: React.ReactElement | undefined = undefined;

            if (solicitudDisponibleParaReintegro !== undefined) {

                const sol = solicitudDisponibleParaReintegro;

                botonSolicitarReintegro = (
                    <Row className="justify-content-start">
                        <Col md="10"></Col>
                        <Col md="2">
                            <button
                                className="button-others-primary mb-1"
                                disabled={!props.puedeSolicitarPorHorario}
                                onClick={() => handleClickSolicitarReintegro(sol)}
                            >
                                Solicitar Reintegro
                            </button>
                        </Col>
                    </Row>
                )
            }


            const solicitudes = (
                <div>
                    {
                        solicitudesVacacionesIngresadas.length > 0 && (
                            <>
                                <strong>Vacaciones solicitadas</strong>
                                {htmlRowsSolicitudesVacaciones}
                            </>

                        )
                    }
                    {
                        solicitudesPermisosIngresados.length > 0 && (
                            <>
                                <strong>Permisos solicitados</strong>
                                {htmlRowsSolicitudesPermisos}
                            </>

                        )
                    }
                    {
                        htmlRowsSolicitudesReintegro !== undefined && props.solicitudesReintegro.length > 0 && (
                            <strong>Reintegros solicitados</strong>
                        )
                    }
                    {
                        htmlRowsSolicitudesReintegro
                    }
                    {
                        botonSolicitarReintegro
                    }

                </div>
            )
            return solicitudes;
        }

    }, [props.solicitudes, props.solicitudesReintegro, props.anioSolicitud, props.puedeSolicitarPorHorario])

    const SolicitudesReplanificacion = useMemo(() => {
        if (props.solicitudReplanificacion !== null) {
            const htmlSolicitudReplanificacionVacaciones = GetHtmlSolicitudReplanificacionVacacionesIngresada(props.solicitudReplanificacion, true);
            const solicitudes = (
                <div>
                    {htmlSolicitudReplanificacionVacaciones}
                </div>
            )
            return solicitudes;
        }

    }, [props.solicitudReplanificacion, props.anioSolicitud])

    const WarnAlert = useMemo(() => {
        if (mensajeError !== "") {
            return (
                <AlertNew
                    mensaje={mensajeError}
                    oncloseElement={() => setmensajeError("")}
                />
            )

        }
    }, [mensajeError])

    const WarnAlertMensajeHorasAlmuerzo = useMemo(() => {
        var mensajeAdvertencia = incluyeHoraAlmuerzo ? "Ud. NO debe registrar su hora de inicio y fin de receso" : "Ud. deberá registrar su hora de inicio y fin de receso";
        if (horarioAlmuerzo && props.idRegimenLaboralSolicitaVacaciones !== REGIMEN_USUARIO.LOES) {
            return (
                <React.Fragment>
                    <Row className="containerWarnHorasAlmuerzo">
                        <Col xl={12}>
                            <Row>
                                <Col xl={12}>
                                    <p className='mb-0'>{"¿El permiso solicitado incluye su tiempo de almuerzo?"}</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col xl={12}>
                                    <Form >
                                        <FormGroup check inline >


                                            <Label check className="labelincluiralmuerzo">

                                                <Input
                                                    name="radio1"
                                                    type="radio"
                                                    checked={incluyeHoraAlmuerzo}
                                                    onChange={(e) => setincluyeHoraAlmuerzo(true)}
                                                />
                                                SI
                                            </Label>

                                            <Label check >
                                                <Input
                                                    name="radio2"
                                                    type="radio"
                                                    checked={!incluyeHoraAlmuerzo}
                                                    onChange={(e) => setincluyeHoraAlmuerzo(false)}
                                                />
                                                NO
                                            </Label>



                                        </FormGroup>
                                    </Form>

                                </Col>
                                <Col xl={12}>
                                    <small className='small-error'>{mensajeAdvertencia}</small>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </React.Fragment>

            )

        }
    }, [horarioAlmuerzo, incluyeHoraAlmuerzo,props.idRegimenLaboralSolicitaVacaciones])


    const ModalEliminarSolicitudesPermisosVacaciones = useMemo(() => {
        return (
            <ModalConfirmacion
                show={stateModal.showModal && (stateModal.solicitud?.idSolicitud ?? -1) > -1}
                size="lg"

                mensajeConfirmacion={'¿Desea eliminar la solicitud?'}
                classNamemensajeConfirmacion='mensajeConfirmacionAnulacionSolicitud'
                tituloModal='Eliminación de Solicitud'
                nombreBotonAccion='Aceptar'
                nombreBotonCerrarModal='Cancelar'
                onClose={() => setstateModal(defaultStateModal)}
                asyncAccion={true}
                asyncClose={true}

                closeAfterAccion={true}
                hideBotonCerrar={false}
                asyncOnClick={async () => AnularSolicitud(stateModal.solicitud?.idSolicitud ?? -1)}
                asyncAfterOnClose={() => OnCloseModalConfirmacionAnulacion()}
                contentModal={stateModal.content}
                classNameAllModal={""}

            />
        )

    }, [stateModal])

    const ModalAnularSolicitudAprobada = useMemo(() => {
        const { feriados } = props;

        const feriadosMapeados = feriados.map((v, i) => { return new Date(v) });

        if (stateModalAnularSolicitudAprobada.solicitudVacacionesAsociada === undefined) {
            return undefined;
        }

        return (
            <ModalAccionAnularSolicitudAprobada
                show={stateModalAnularSolicitudAprobada.idSolicitudVacaciones > 0 || stateModalAnularSolicitudAprobada.cargando}
                size="lg"
                onClose={() => setstateModalAnularSolicitudAprobada(defaultStateModalAnularSolicitud)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={stateModalAnularSolicitudAprobada.mensajeBody}
                nombreBotonAccion={"ACEPTAR"}
                nombreBotonCerrarModal={"CANCELAR"}
                asyncOnClick={async (observacion: string, listadoRepl: Replanificacion[]) => await AnularSolicitudAprobada(stateModalAnularSolicitudAprobada.idSolicitudVacaciones, observacion, listadoRepl)}
                contentModal={stateModalAnularSolicitudAprobada.content}
                tituloModal={stateModalAnularSolicitudAprobada.tituloModal}
                asyncAfterOnClose={async () => await OnCloseModalConfirmacionAnulacion()}
                labelObservacion={"Indique el motivo"}
                maxLength={300}
                cargando={stateModalAnularSolicitudAprobada.cargando}

                solicitudVacaciones={stateModalAnularSolicitudAprobada.solicitudVacacionesAsociada}
                feriados={feriadosMapeados}
                fechasLicencia={props.fechasLicencia}
                fechasPermisosMedicos={props.fechasPermisosMedicos}
                solicitudes={props.solicitudes}
                planificaciones={props.planificaciones}
                anioPlanificacion={props.anioSolicitud}
                fechaCorteSoloJustificaPlanificacion={props.fechaCorteSoloJustificaPlanificacion}


            />
        )

    }, [stateModalAnularSolicitudAprobada])

    const ModalSolicitarReintegro = useMemo(() => {
        const { feriados } = props;

        const feriadosMapeados = feriados.map((v, i) => { return new Date(v) });
        const planificacionesDelAnio = props.planificaciones.filter(pl => {
            const anioPlanificacion = +ObtenerFechaFromIsoFormat(pl.fechaInicio.toString()).split("/")[2];
            return anioPlanificacion == props.anioSolicitud
        });
        return (
            <ModalReintegro
                show={(stateModalSolicitarReintegro.solicitudVacaciones.idSolicitud ?? 0) > 0}
                size="lg"
                onClose={() => setstateModalSolicitarReintegro(defaultStateModalReintegro)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={""}
                nombreBotonAccion={"ACEPTAR"}
                nombreBotonCerrarModal={"CANCELAR"}
                asyncOnClick={async (observacion, fechaReintegro, listadoReplanificacion) => await SolicitarReintegro(stateModalSolicitarReintegro.solicitudVacaciones.idSolicitud ?? 0, observacion, fechaReintegro, listadoReplanificacion)}
                contentModal={stateModalSolicitarReintegro.content}
                tituloModal={"Solicitud de Reintegro de Vacaciones"}
                asyncAfterOnClose={async () => await OnCloseModalConfirmacionAnulacion()}
                labelObservacion={"Indique el motivo"}

                labelFechaReintegro={"Fecha desde que se reintegra"}

                solicitudVacaciones={stateModalSolicitarReintegro.solicitudVacaciones}
                feriados={feriadosMapeados}
                fechasLicencia={props.fechasLicencia}
                fechasPermisosMedicos={props.fechasPermisosMedicos}
                solicitudes={props.solicitudes}
                planificaciones={planificacionesDelAnio}
                anioPlanificacion={props.anioSolicitud}

                maxlengthObservacion={300}
                fechaCorteSoloJustificaPlanificacion={props.fechaCorteSoloJustificaPlanificacion}

            // classNamemensajeConfirmacion = {"mensajeModalsSolicitudVacaciones"}

            />
        )
    }, [stateModalSolicitarReintegro, props.planificaciones])

    const ModalEliminarSolicitudReplanificacion = useMemo(() => {

        return (
            <ModalConfirmacion
                show={stateModalAnularSolicitudReplanificacion.showModal && stateModalAnularSolicitudReplanificacion.idSolicitud > -1}
                size="lg"
                mensajeConfirmacion={'¿Desea eliminar la solicitud?'}
                classNamemensajeConfirmacion='mensajeConfirmacionAnulacionSolicitud'
                tituloModal='Eliminación de Solicitud'
                nombreBotonAccion='Aceptar'
                nombreBotonCerrarModal='Cancelar'
                onClose={() => setstateModalAnularSolicitudReplanificacion(defaultStateModalAnulacionReplanificacion)}
                asyncAccion={true}
                asyncClose={true}

                closeAfterAccion={true}
                hideBotonCerrar={false}
                asyncOnClick={async () => AnularSolicitudReplanificacion(stateModalAnularSolicitudReplanificacion.idSolicitud)}
                asyncAfterOnClose={() => OnCloseModalConfirmacionAnulacion()}
                contentModal={stateModalAnularSolicitudReplanificacion.content}
                classNameAllModal={""}
            />
        )


    }, [stateModalAnularSolicitudReplanificacion])

    async function OnCloseModalConfirmacionAnulacion() {
        // setstateModal(defaultStateModal);
        await props.onInsertSolicitud()
        ScrollToTop();

    }

    const AuxiliarCrearSolicitudVacacionesPost = useCallback(
        () => {
            const condicionPermisoPorHoras = habilitarIngresoHoras && fraccionHoraDia !== undefined && fraccionHoraDia < 1 && fechaPermisoHora !== null && horaDesde !== undefined && horaHasta !== undefined;
            const listadoIdPlanificacionesNoEjecutadas = ObtenerListadoIdPlanificacionesNoEjecutadas(props.planificacionesNoEjecutadas)

            var solicitudNueva: SolicitudVacacionesPost | undefined = undefined;



            if (stateCard.fechaDesde !== null && stateCard.fechaHasta !== null && !condicionPermisoPorHoras) {

                const nroDiasOrdinarios: number = function_calcular_dias_ordinarios(new Date(stateCard.fechaDesde), new Date(stateCard.fechaHasta));

                solicitudNueva = {
                    FechaInicio: PruebaSolucion2(stateCard.fechaDesde),
                    FechaFin: PruebaSolucion2(stateCard.fechaHasta),
                    justificacion: justificacionPermiso,
                    ListadoPlanificacionesNoEjecutadas: listadoIdPlanificacionesNoEjecutadas,
                    JustificacionPlanificacionesNoEjecutadas: justificacionPlanificacionNoEjec,
                    PermisoPorHora: false,
                    PermisoPorDia: permisoCargoVacaciones,
                    PermisoHoraIncluyeAlmuerzo: incluyeHoraAlmuerzo || descontandoTiempoAlmuerzo,
                    NroDiasOrdinarios: nroDiasOrdinarios

                }

            } else if (condicionPermisoPorHoras && fechaPermisoHora !== null && horaDesde !== undefined && horaHasta !== undefined && justificacionPermisoHora !== "") {

                const fechaDesdeConHoras = AgregarHoraAFecha(fechaPermisoHora, horaDesde)
                const fechaHastaConHoras = AgregarHoraAFecha(fechaPermisoHora, horaHasta)


                solicitudNueva = {
                    FechaInicio: PruebaSolucion2(fechaDesdeConHoras),
                    FechaFin: PruebaSolucion2(fechaHastaConHoras),
                    justificacion: justificacionPermisoHora,
                    ListadoPlanificacionesNoEjecutadas: listadoIdPlanificacionesNoEjecutadas,
                    JustificacionPlanificacionesNoEjecutadas: justificacionPlanificacionNoEjec,
                    PermisoPorHora: true,
                    PermisoPorDia: permisoCargoVacaciones,
                    PermisoHoraIncluyeAlmuerzo: incluyeHoraAlmuerzo || descontandoTiempoAlmuerzo,
                    NroDiasOrdinarios: 0
                }

            }

            return solicitudNueva;
        },
        [stateCard, justificacionPermiso, permisoCargoVacaciones, justificacionPlanificacionNoEjec, habilitarIngresoHoras, fraccionHoraDia, fechaPermisoHora, horaDesde, horaHasta, justificacionPermisoHora, incluyeHoraAlmuerzo, descontandoTiempoAlmuerzo],
    )


    const OnClickAccionModalFormulario = useCallback(async () => {

        const { fechaDesde, fechaHasta } = stateCard;
        var respuesta: ResponseRequest = { status: -1 };
        if ((fechaDesde !== null && fechaHasta !== null) || fechaPermisoHora !== null) {


            // const listadoIdPlanificacionesNoEjecutadas = ObtenerListadoIdPlanificacionesNoEjecutadas(props.planificacionesNoEjecutadas)
            // const solicitudNueva: SolicitudVacacionesPost = {
            //     FechaInicio: PruebaSolucion2(fechaDesde),
            //     FechaFin: PruebaSolucion2(fechaHasta),
            //     justificacion: justificacionPermiso,
            //     ListadoPlanificacionesNoEjecutadas: listadoIdPlanificacionesNoEjecutadas,
            //     JustificacionPlanificacionesNoEjecutadas: justificacionPlanificacionNoEjec,
            //     PermisoPorHora: false
            // }

            const solicitudNueva = AuxiliarCrearSolicitudVacacionesPost();

            if (solicitudNueva === undefined) {
                alertService.error("No ha sido posible ingresar la solicitud");
            }
            else {
                respuesta = await SolicitarVacacionesCreacion(solicitudNueva);

            }

            if (respuesta.status === 200) {

                if (permisoCargoVacaciones) {
                    alertService.success("Se ha ingresado la solicitud de permiso imputable a vacaciones")
                }
                else if (fechaPermisoHora !== null) {
                    alertService.success("Se ha ingresado la solicitud de permiso por horas imputable a vacaciones")
                }
                else {
                    alertService.success("Se ha ingresado la solicitud de vacaciones")
                }


                // setstateCard({ ...stateCard, fechaDesde: null, fechaHasta: null })
                
                //limpiarFechasCardYModal()

                await props.onInsertSolicitud();

                ScrollToTop();
            }
            else {
                alertService.error(respuesta.errorMessage ?? "No ha sido posible ingresar la solicitud de vacaciones.Intente más tarde")
                // setstateModalFormulario(defaultStateModalFormulario)
                // setstateCard({ ...stateCard, fechaDesde: null, fechaHasta: null })
                limpiarFechasCardYModal()

                await props.onInsertSolicitud();
                ScrollToTop();
            }

        }



    }
        , [stateCard, justificacionPermiso, permisoCargoVacaciones, fechaPermisoHora, justificacionPlanificacionNoEjec, mostrarcomponentePlanificacionesNoEjec, limpiarFechasCardYModal, AuxiliarCrearSolicitudVacacionesPost])




    const ComponentePermisoCargoVacaciones = useMemo(() => {

        // const esCodigoTrabajo: boolean = VerificarServidorSoloTieneCodigoTrabajo(props.idRegimenLaboral);

        // if (esCodigoTrabajo) {
        //     return undefined
        // }
        

        const deshabilitarBotonPermisoCargoVacaciones = justificacionPermiso === "" || (mostrarcomponentePlanificacionesNoEjec && justificacionPlanificacionNoEjec === "") || !props.puedeSolicitarPorHorario

        const htmlcomponente = (<>
            <Row>
                <Col xl={12} lg={12} md={12}>
                    <p className='small-error'>
                        {/* {`Ud. ha ingresado una solicitud por ${ndiasEscogidos} ${ndiasEscogidos === 1 ? "día" : "días"} que no se encuentra en la planificación, por lo tanto, esto será considerado como un permiso imputable a vacaciones. Acepte la justificación de su permiso.`} */}
                        {MENSAJE_CUANDO_SOLICITA_PERMISO_IMPUTABLE}
                    </p>
                </Col>
            </Row>
            <Row>
                <Col md={10} lg={10}>
                    <FormGroup>
                        <Label for="justificacionPermisop">
                            {`Justificación `}
                        </Label>

                        <Input
                            type="select"
                            id="justificacionPermisop"
                            name="justificacionPermisop"
                            value={justificacionPermiso}
                            onChange={(e) => setjustificacionPermiso(e.target.value)}
                        >
                            {
                                OPCIONES_SELECT_JUSTIFICACION_PERMISO.map((opcion, indiceOpcion) => {
                                    return (
                                        <option key={"justificacionPermiso " + indiceOpcion} value={opcion}>{opcion}</option>
                                    )
                                })
                            }

                        </Input>

                    </FormGroup>
                </Col>
                <Col md={2} lg={2} className="align-self-end mb-1 mr-auto  mt-auto d-flex justify-content-start">
                    <Button disabled={deshabilitarBotonPermisoCargoVacaciones} data-bs-toggle="tooltip" data-bs-placement="top" title={"Se creará solicitud de permiso con cargo a vacaciones"} className="primary " type="button" onClick={() => handleClickSolicitar()} >{"ACEPTAR"}</Button>
                </Col>
            </Row>
        </>
        )

        if (permisoCargoVacaciones) {
            return htmlcomponente
        }
        else {
            return undefined
        }




    }, [permisoCargoVacaciones, mostrarcomponentePlanificacionesNoEjec, justificacionPlanificacionNoEjec, justificacionPermiso, stateCard.fechaDesde, stateCard.fechaHasta, props.idRegimenLaboral, props.puedeSolicitarPorHorario])

    const ComponentePermisoHorasCargoVacaciones = useMemo(() => {


        const deshabilitarBotonPermisoCargoVacaciones = justificacionPermisoHora === "" || (mostrarcomponentePlanificacionesNoEjec && justificacionPlanificacionNoEjec === "") || errorHoras !== ""

        const htmlcomponente = (<>

            <Row>
                <Col md={10} lg={10}>
                    <FormGroup>
                        <Label for="justificacionPermisop">
                            {`Justificación `}
                        </Label>

                        <Input
                            type="select"
                            id="justificacionPermisoHoras"
                            name="justificacionPermisoHoras"
                            value={justificacionPermisoHora}
                            onChange={(e) => setjustificacionPermisoHora(e.target.value)}
                        >
                            {
                                OPCIONES_SELECT_JUSTIFICACION_PERMISO.map((opcion, indiceOpcion) => {
                                    return (
                                        <option key={"justificacionPermisoHora " + indiceOpcion} value={opcion}>{opcion}</option>
                                    )
                                })
                            }

                        </Input>

                    </FormGroup>
                </Col>
                <Col md={2} lg={2} className="align-self-end mb-1 mr-auto  mt-auto d-flex justify-content-start">
                    <Button disabled={!props.puedeSolicitarPorHorario || deshabilitarBotonPermisoCargoVacaciones} data-bs-toggle="tooltip" data-bs-placement="top" title={"Se creará solicitud de permiso por hora con cargo a vacaciones"} className="primary " type="button" onClick={() => handleClickSolicitar()} >{"ACEPTAR"}</Button>
                </Col>
            </Row>
        </>
        )

        if (fechaPermisoHora !== null && horaDesde !== undefined && horaHasta !== undefined && horaDesde !== "" && horaHasta !== "") {
            return htmlcomponente
        }
        else {
            return undefined;
        }






    }, [mostrarcomponentePlanificacionesNoEjec, justificacionPlanificacionNoEjec, errorHoras, justificacionPermisoHora, fechaPermisoHora, fraccionHoraDia, horaDesde, horaHasta, props.idRegimenLaboral, horarioAlmuerzo, props.puedeSolicitarPorHorario])




    const ComponenteJustificarPlanificacionesNoEjecutadas = useMemo(() => {
        const estaPidiendoPermisoPorHoras = fechaPermisoHora !== null && horaDesde !== undefined && horaHasta !== undefined && horaDesde !== "" && horaHasta !== "";
        if (mostrarcomponentePlanificacionesNoEjec) {

            const htmlcomponente = (<>
                <Row>
                    <Col xl={12} lg={12} md={12}>
                        <p className='small-error'>
                            {MENSAJE_JUSTIFICAR_VACACIONES_NO_PLANIFICADAS}
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col md={10} lg={10}>
                        <FormGroup>
                            <Label for="justificacionPlanifNoEjec">
                                {`Justificación `}
                            </Label>

                            <Input
                                type="select"
                                id="justificacionPlanifNoEjec"
                                name="justificacionPlanifNoEjec"
                                value={justificacionPlanificacionNoEjec}
                                onChange={(e) => setjustificacionPlanificacionNoEjec(e.target.value)}
                            >
                                {
                                    OPCIONES_SELECT_JUSTIFICACION_PLANIFICACIONES_NO_EJECUTADAS.map((opcion, indiceOpcion) => {
                                        return (
                                            <option key={"justificacionPlanificacionNoEjec" + indiceOpcion} value={opcion}>{opcion}</option>
                                        )
                                    })
                                }


                            </Input>

                        </FormGroup>
                    </Col>
                    {
                        !permisoCargoVacaciones && !estaPidiendoPermisoPorHoras &&
                        <Col md={2} lg={2} className="align-self-end mb-1 mr-auto  mt-auto d-flex justify-content-start">
                            <Button disabled={!props.puedeSolicitarPorHorario || justificacionPlanificacionNoEjec === ""} data-bs-toggle="tooltip" data-bs-placement="top" title={"Se creará solicitud de vacaciones"} className="primary " type="button" onClick={() => handleClickSolicitar()} >{"ACEPTAR"}</Button>
                        </Col>
                    }

                </Row>
            </>);

            return htmlcomponente;
        }
        else {
            return undefined
        }
    }, [mostrarcomponentePlanificacionesNoEjec, justificacionPlanificacionNoEjec, permisoCargoVacaciones, justificacionPermisoHora, fechaPermisoHora, horaDesde, horaHasta, props.puedeSolicitarPorHorario])


    const ErrorPermiso = useMemo(() => {
        if (tabActiva === TabSolicitudActiva.PERMISOS_IMPUTABLES && subtabActiva === TabSolicitudActiva.PERMISOS_IMPUTABLES_DIAS && stateCard.fechaDesde !== null && stateCard.fechaHasta !== null) {
            const fd = new Date(stateCard.fechaDesde);
            const fh = new Date(stateCard.fechaHasta);
            const diasOrdinarios = function_calcular_dias_ordinarios(fd, fh);

            if (diasOrdinarios > props.nroMaximoDiasOrdinariosImputablesVacaciones) {
                return (
                    <small className='small-error'> Los permisos imputables, no pueden exceder los {props.nroMaximoDiasOrdinariosImputablesVacaciones} días ordinarios </small>
                )
            }
        }

        return undefined;

    }, [tabActiva, subtabActiva, stateCard.fechaDesde, stateCard.fechaHasta])

    const ToogleTab = useCallback(
        (tabDeseada: TabSolicitudActiva, subTab: boolean) => {

            

            if (tabDeseada === TabSolicitudActiva.PERMISOS_IMPUTABLES || tabDeseada === TabSolicitudActiva.REPROGRAMACION) {
                var win = window.open("https://th.espol.edu.ec/user/informacion-laboral/vacaciones", '_blank');
                win?.focus();
            }
            else {
                setbloquearChecks(tabDeseada !== TabSolicitudActiva.VACACIONES_PLANIFICADAS);
                if (tabDeseada !== tabActiva) {
                    if (!subTab) {
                        settabActiva(tabDeseada);
                    }
                    else {
                        setsubtabActiva(tabDeseada)
                    }
                    setmensajeError("");
                    setpermisoCargoVacaciones(false)
                    setjustificacionPermiso("")
                    setmostrarcomponentePlanificacionesNoEjec(false)
                    setjustificacionPlanificacionNoEjec("")
                    setstateCard(defaultState)
                    setdetalleDiasSolicitudVacacion(undefined)
                }
            }
            

            
        }
        , [tabActiva])


    function MostrarPermisosIngresados(permisos: FechasPermisosMedicosVacaciones[]) {
        var fechaActual = new Date();
        fechaActual = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate());


        var contadorNull: number = 0;
        var arregloDivFechas: JSX.Element[] = []
        if (permisos.length > 0) {

            arregloDivFechas = permisos.map((p, i) => {
                const fechaDesdeParse = new Date(p.fechaDesde);
                const fechaHastaParse = new Date(p.fechaHasta);

                if (p.permitirEnHoras && (fechaActual.getTime() < fechaDesdeParse.getTime() || (fechaDesdeParse.getTime() <= fechaActual.getTime() && fechaActual.getTime() <= fechaHastaParse.getTime()))) {
                    return (
                        <React.Fragment>
                            <div>
                                fecha inicio : {ObtenerFechaFromIsoFormat(p.fechaDesde.toString())} - fecha fin : {ObtenerFechaFromIsoFormat(p.fechaHasta.toString())}
                            </div>
                            <div>
                                hora inicio : {p.horaDesde} - hora fin: {p.horaHasta}
                            </div>
                        </React.Fragment>

                    )
                }
                contadorNull += 1;
                return <span></span>
            })

            if (arregloDivFechas.length > 0 && (contadorNull != arregloDivFechas.length)) {
                return (
                    <div>
                        <div> Recuerde que tiene permisos ingresados/aprobados en las siguientes fechas: </div>
                        {
                            arregloDivFechas
                        }
                        {/* <div className="small-error"> Si ud. desea tomar permiso por días en una de las fechas anteriores, primero debe anular los permisos ingresados.</div> */}
                        <div className="small-error"> Si ud. desea tomar permiso por días en una de las fechas anteriores, se descontará su día completo.</div>

                    </div>
                )
            }
            else {
                return undefined;
            }



        }
    }

    const TabNavegacion = useCallback(
        (nombre: string, tipodeTab: TabSolicitudActiva, subTab: boolean, estilosClassName?: string) => {

            var mensajeToolTip = "";

            if (!subTab) {
                switch (tipodeTab) {
                    case TabSolicitudActiva.VACACIONES_PLANIFICADAS:
                        mensajeToolTip = "Solicitud de vacaciones planificadas o reprogramadas. Puede ser realizada desde 3 meses hasta un dia antes del inicio de sus vacaciones"
                        break;
                    case TabSolicitudActiva.PERMISOS_IMPUTABLES:
                        mensajeToolTip = "Solicitud por horas, fracción de horas o días no planificados. Si el permiso es por horas o fracción, la solicitud debe ser hecha hasta un día después de haberse acogido al permiso. Si el permiso es por uno o más días, la solicitud debe ser hecha hasta un día antes de acogerse al permiso"
                        break;
                    case TabSolicitudActiva.REINTEGRO:
                        mensajeToolTip = "Solicitud para reincorporar a sus funciones, a un servidor, por razones debidamente fundamentadas y de común acuerdo con su directivo, mientras está gozando de sus vacaciones."
                        break;
                    case TabSolicitudActiva.REPROGRAMACION:
                        mensajeToolTip = "Justificación de las vacaciones planificadas no ejecutadas y/o reprogramación de la planificación de vacaciones. Recuerde hacerlo por lo menos quince días antes de la fecha prevista."
                        break;
                    default:
                        break;
                }
            }

            return (
                <NavLink
                    className={classnames({ active: subTab ? subtabActiva === tipodeTab : tabActiva === tipodeTab }) + " " + estilosClassName ?? ""}
                    onClick={() => { ToogleTab(tipodeTab, subTab) }}
                    data-toggle="tooltip"
                    data-placement="top"
                    title={mensajeToolTip}
                >
                    {nombre}
                </NavLink>
            )
        }, [tabActiva, subtabActiva])

    useEffect(() => {

        if (subtabActiva !== TabSolicitudActiva.PERMISOS_IMPUTABLES_HORAS) {
            setfraccionHoraDia(undefined)
            setHorasSolicitdas(undefined)
            setfechaPermisoHora(null)
            seterrorHoras("")
            setmensajePermisoMedico("")
        }




        switch (tabActiva) {
            case TabSolicitudActiva.REPROGRAMACION:
                setmostrarModalReplanificacion(true);
                break;

            default:
                setmostrarModalReplanificacion(false);
                break;
        }
    }, [tabActiva, subtabActiva])


    useEffect(() => {
        if (!mostrarModalReplanificacion) {
            setbloquearChecks(false);
        }
    }, [mostrarModalReplanificacion])


    function OnChangeHoraDesde(e: any) {

        setHoraDesde(e.target.value);
        setHoraHasta("")
    }
    const inputHoraDesde = useCallback(
        () => {
            // <Input type="text" value={saldoDias} readOnly id="saldo_dias_solicitudes"></Input>

            return (
                <Input disabled={!habilitarIngresoHoras} type="time" className="inputTime" value={horaDesde} onChange={(e) => OnChangeHoraDesde(e)} />
            )

        },
        [horaDesde, habilitarIngresoHoras]
    )

    const inputHoraHasta = useCallback(
        () => {

            return (
                <>
                    <Input disabled={!habilitarIngresoHoras || (horaDesde !== undefined && horaHasta === undefined && errorHoras !== "") || horaDesde === undefined || horaDesde === ""} type="time" className="inputTime" min={"08:01"} max={"16:30"} value={horaHasta} onChange={(e) => setHoraHasta(e.target.value)} />
                </>
            )

        },
        [horaDesde, horaHasta, habilitarIngresoHoras, errorHoras]
    )




    useEffect(() => {



        const horaDesdeExiste = horaDesde !== undefined && horaDesde !== ""
        const horaHastaExiste = horaHasta !== undefined && horaHasta !== ""

        const horaHastaNoExiste = horaHasta === undefined || (horaHasta !== undefined && horaHasta === "")
        const horaDesdeNoExiste = horaDesde === undefined || (horaDesde !== undefined && horaDesde === "")

        var fechasPermisosMedicos: FechaHora[] = [];
        var pidioPermisoEnFechaEscogida = false;
        var horaInicioPermisoMedico: string[] = [];
        var horaFinPermisoMedico: string[] = [];
        var fechaPermisoCoincideFechaEscogida: FechaHora[] = [];

        if (fechaPermisoHora !== null && props.fechasPermisosMedicos.length > 0) {

            props.fechasPermisosMedicos.map((val, ind) => {
                fechasPermisosMedicos = [...fechasPermisosMedicos, ...obtener_rango_fechas_horas_no_weekend(val.fechaDesde, val.fechaHasta, val.horaDesde, val.horaHasta)]
            })

            const fechaEscogida = new Date(fechaPermisoHora);

            fechaPermisoCoincideFechaEscogida = fechasPermisosMedicos.filter((v) => v.fecha.getTime() === fechaEscogida.getTime());

            pidioPermisoEnFechaEscogida = fechaPermisoCoincideFechaEscogida.length > 0;

            for (let index = 0; index < fechaPermisoCoincideFechaEscogida.length; index++) {
                const fechaPermisoMedico = fechaPermisoCoincideFechaEscogida[index];
                horaInicioPermisoMedico.push(fechaPermisoMedico.horaInicio);
                horaFinPermisoMedico.push(fechaPermisoMedico.horaFin);
            }



            if (pidioPermisoEnFechaEscogida) {

                var mensajeHorarios: string = "";

                for (let index = 0; index < fechaPermisoCoincideFechaEscogida.length; index++) {
                    const fechaPermisoMedico = fechaPermisoCoincideFechaEscogida[index];
                    mensajeHorarios += `${fechaPermisoMedico.horaInicio} - ${fechaPermisoMedico.horaFin}`
                    if (index != fechaPermisoCoincideFechaEscogida.length - 1) {
                        mensajeHorarios += "; "
                    }

                }

                if (mensajeHorarios !== mensajePermisoMedico) {
                    setmensajePermisoMedico(`Ha escogido una fecha en la que tiene permiso en el siguiente horario: ${mensajeHorarios}`);
                }



            } else if (!pidioPermisoEnFechaEscogida) {
                setmensajePermisoMedico("")
            }
        }




        if (fechaPermisoHora !== null && horarioParaPermisoHora && (horaDesde !== undefined && horaDesde !== "") && (horaHasta === undefined || (horaHasta !== undefined && horaHasta === ""))) {
            const fechaEscogida = new Date(fechaPermisoHora);

            // const [hora_inicio_permitida, minuto_inicio_permitido] = HORA_INICIO_PERMITIDA.split(":");
            // const [hora_fin_permitida, minuto_fin_permitido] = HORA_FIN_PERMITIDA.split(":");

            //SE USAN LAS HORAS DEL HORARIO QUE TIENE EN ESE DIA
            const [hora_inicio_permitida, minuto_inicio_permitido] = horarioParaPermisoHora.horaEntrada.split(":");
            const [hora_fin_permitida, minuto_fin_permitido] = horarioParaPermisoHora.horaSalida.split(":");


            const horaMinima = add(fechaEscogida, { hours: +hora_inicio_permitida, minutes: +minuto_inicio_permitido });
            const horaMaxima = add(fechaEscogida, { hours: +hora_fin_permitida, minutes: +minuto_fin_permitido - 1 });


            const [hora_desde_seleccionada, minuto_desde] = horaDesde.split(":");

            const horaDesdeSeleccionada = add(fechaEscogida, { hours: +hora_desde_seleccionada, minutes: +minuto_desde });

            var horaInterfiereConPermisoMedico = false;

            if (pidioPermisoEnFechaEscogida) {

                for (let index = 0; index < horaInicioPermisoMedico.length; index++) {

                    const [hora_inicio_permisoMedico, minuto_inicio_permisoMedico] = horaInicioPermisoMedico[index].split(":");
                    const [hora_fin_permisoMedico, minuto_fin_permisoMedico] = horaFinPermisoMedico[index].split(":");


                    const horaDesdePermisoMedico = add(fechaEscogida, { hours: +hora_inicio_permisoMedico, minutes: +minuto_inicio_permisoMedico });
                    const horaHastaPermisoMedico = add(fechaEscogida, { hours: +hora_fin_permisoMedico, minutes: +minuto_fin_permisoMedico });


                    horaInterfiereConPermisoMedico = horaDesdePermisoMedico.getTime() <= horaDesdeSeleccionada.getTime() && horaDesdeSeleccionada.getTime() < horaHastaPermisoMedico.getTime();
                    if (horaInterfiereConPermisoMedico) {
                        index = horaInicioPermisoMedico.length;
                    }
                }



            }

            if (horaInterfiereConPermisoMedico) {
                seterrorHoras("La hora escogida interfiere con su permiso")
            }
            else if (horaDesdeSeleccionada.getTime() < horaMinima.getTime() || horaDesdeSeleccionada.getTime() > horaMaxima.getTime()) {
                seterrorHoras(MENSAJE_ERROR_LIMITES_HORARIO_LABORAL);
            }
            
            else {
                seterrorHoras("")
                setHorasSolicitdas(undefined);
                setfraccionHoraDia(undefined);

            }
        }

        else if (fechaPermisoHora !== null && horarioParaPermisoHora && (horaDesde !== undefined && horaDesde !== "") && (horaHasta !== undefined && horaHasta !== "")) {

            const fechaEscogida = new Date(fechaPermisoHora);

            // const [hora_inicio_permitida, minuto_inicio_permitido] = HORA_INICIO_PERMITIDA.split(":");
            // const [hora_fin_permitida, minuto_fin_permitido] = HORA_FIN_PERMITIDA.split(":");

            //SE USAN LAS HORAS DEL HORARIO QUE TIENE EN ESE DIA
            const [hora_inicio_permitida, minuto_inicio_permitido] = horarioParaPermisoHora.horaEntrada.split(":");
            const [hora_fin_permitida, minuto_fin_permitido] = horarioParaPermisoHora.horaSalida.split(":");


            const [hora_desde_seleccionada, minuto_desde] = horaDesde.split(":");
            const [hora_hasta_seleccionada, minuto_hasta] = horaHasta.split(":");


            // const [hora_entrada, minuto_entrada] = HORA_INICIO_PERMITIDA.split(":");
            // const [hora_salida, minuto_salida] = HORA_FIN_PERMITIDA.split(":");

            //SE USAN LAS HORAS DEL HORARIO QUE TIENE EN ESE DIA
            const [hora_entrada, minuto_entrada] = horarioParaPermisoHora.horaEntrada.split(":");
            const [hora_salida, minuto_salida] = horarioParaPermisoHora.horaSalida.split(":");

            const [hora_inicio_almuerzo, minuto_inicio_almuerzo] = RANGO_INICIO_ALMUERZO.split(":");
            const [hora_fin_almuerzo, minuto_fin_almuerzo] = RANGO_FIN_ALMUERZO.split(":");


            const horaMinima = add(fechaEscogida, { hours: +hora_inicio_permitida, minutes: +minuto_inicio_permitido });
            const horaMaxima = add(fechaEscogida, { hours: +hora_fin_permitida, minutes: +minuto_fin_permitido });


            const tiempoAlmuerzo = TIEMPO_ALMUERZO.split(':');
            const tiempoAlmuerzoMinutos = (+tiempoAlmuerzo[0]) * 60 + (+tiempoAlmuerzo[1]);

            const horaMaximaSinAlmuerzo = add(fechaEscogida, { hours: +hora_fin_permitida, minutes: +minuto_fin_permitido - tiempoAlmuerzoMinutos });


            const horaDesdeSeleccionada = add(fechaEscogida, { hours: +hora_desde_seleccionada, minutes: +minuto_desde });
            const horaHastaSeleccionada = add(fechaEscogida, { hours: +hora_hasta_seleccionada, minutes: +minuto_hasta });


            const horaEntradaDelDia = add(fechaEscogida, { hours: +hora_entrada, minutes: +minuto_entrada })
            const horaSalidaDelDia = add(fechaEscogida, { hours: +hora_salida, minutes: +minuto_salida })

            const diferenciaHorasHorarioLaboral = (+differenceInMinutes(horaSalidaDelDia, horaEntradaDelDia)) / 60;

            const diferenciaMinutosPermisoHoras = differenceInMinutes(horaHastaSeleccionada, horaDesdeSeleccionada)

            var horaInterfiereConPermisoMedico = false;

            if (pidioPermisoEnFechaEscogida) {

                for (let index = 0; index < horaInicioPermisoMedico.length; index++) {

                    const [hora_inicio_permisoMedico, minuto_inicio_permisoMedico] = horaInicioPermisoMedico[index].split(":");
                    const [hora_fin_permisoMedico, minuto_fin_permisoMedico] = horaFinPermisoMedico[index].split(":");


                    const horaDesdePermisoMedico = add(fechaEscogida, { hours: +hora_inicio_permisoMedico, minutes: +minuto_inicio_permisoMedico });
                    const horaHastaPermisoMedico = add(fechaEscogida, { hours: +hora_fin_permisoMedico, minutes: +minuto_fin_permisoMedico });


                    const horaDesdeInterfierePermisoMedico = horaDesdePermisoMedico.getTime() <= horaDesdeSeleccionada.getTime() && horaDesdeSeleccionada.getTime() < horaHastaPermisoMedico.getTime();
                    const horaHastaInterfierePermisoMedico = horaDesdePermisoMedico.getTime() < horaHastaSeleccionada.getTime() && horaHastaSeleccionada.getTime() <= horaHastaPermisoMedico.getTime();

                    horaInterfiereConPermisoMedico = horaDesdeInterfierePermisoMedico || horaHastaInterfierePermisoMedico

                    if (horaInicioPermisoMedico) {
                        index = horaInicioPermisoMedico.length;
                    }

                }



            }



            var traslapa = TraslapaHoras(horasPermisoHoraDelDia,horaDesde,horaHasta);

            if (horaHastaSeleccionada.getTime() < horaDesdeSeleccionada.getTime()) {
                seterrorHoras("La hora hasta no puede ser menor a la hora desde");
            }
            else if (horaInterfiereConPermisoMedico) {
                seterrorHoras("La hora escogida interfiere con un permiso ingresado")
            }
            else if(horasPermisoHoraDelDia.length > 0 && traslapa.traslapa){
                seterrorHoras(`La hora seleccionada se traslapa con otro permiso existente entre las ${traslapa.horadesdetraslapan} y las ${traslapa.horahastatraslapan}. Por favor, elige un horario diferente.`)
            }
            else if (horaDesdeSeleccionada.getTime() === horaMinima.getTime() && (horaHastaSeleccionada.getTime() === horaMaxima.getTime() || horaHastaSeleccionada.getTime() === horaMaximaSinAlmuerzo.getTime()) && diferenciaHorasHorarioLaboral >= HORAS_TRABAJO_POR_DIA) {
                setfraccionHoraDia(1);
                setHorasSolicitdas(HORAS_TRABAJO_POR_DIA + ":00");
                seterrorHoras("")
            }
            else {

                if (horaHastaSeleccionada.getTime() < horaDesdeSeleccionada.getTime()) {
                    seterrorHoras(MENSAJE_ERROR_LIMITES_HORARIO_LABORAL);

                }
                else if (horaDesdeSeleccionada.getTime() < horaMinima.getTime()) {
                    seterrorHoras(MENSAJE_ERROR_LIMITES_HORARIO_LABORAL);
                }
                else if (horaHastaSeleccionada.getTime() > horaMaxima.getTime()) {
                    seterrorHoras(MENSAJE_ERROR_LIMITES_HORARIO_LABORAL);
                }
                else if (diferenciaMinutosPermisoHoras < props.cantidadMinutosMinimosPermisos) {
                    seterrorHoras("Ud puede solicitar este tipo de permiso, desde " + props.cantidadMinutosMinimosPermisos.toString() + " minutos en adelante")
                    setHorasSolicitdas(undefined);
                    setfraccionHoraDia(undefined);

                }
                else {
                    seterrorHoras("")
                    var valorRestarEnMinutos = 0;



                    const horaInicioAlmuerzo = add(fechaEscogida, { hours: +hora_inicio_almuerzo, minutes: +minuto_inicio_almuerzo })
                    const horaFinAlmuerzo = add(fechaEscogida, { hours: +hora_fin_almuerzo, minutes: +minuto_fin_almuerzo })

                    const horamaximaInicioAlmuerzo = add(horaFinAlmuerzo, { minutes: -tiempoAlmuerzoMinutos })
                    const horamaximaFinalizaAlmuerzo = add(horaInicioAlmuerzo, { minutes: +tiempoAlmuerzoMinutos })




                    const diferenciaMinutos = +differenceInMinutes(horaHastaSeleccionada, horaDesdeSeleccionada);



                    // if (CompareRangeBetweenDatesAlmuerzo(horaInicioAlmuerzo, horaFinAlmuerzo, horaDesdeSeleccionada, horaHastaSeleccionada) && diferenciaMinutos <= tiempoAlmuerzoMinutos) {
                    //     sethorarioAlmuerzo(true);
                    //     setHorasSolicitdas(undefined);
                    //     setfraccionHoraDia(undefined)
                    //     return;
                    // }
                    // else if (CompareRangeBetweenDatesAlmuerzo(horaInicioAlmuerzo, horaFinAlmuerzo, horaDesdeSeleccionada, horaHastaSeleccionada) && diferenciaMinutos > tiempoAlmuerzoMinutos && horaDesdeSeleccionada.getTime() <= horamaximaInicioAlmuerzo.getTime() && horaHastaSeleccionada.getTime() >= horamaximaFinalizaAlmuerzo.getTime()) {
                    //     valorRestarEnMinutos = tiempoAlmuerzoMinutos;
                    //     sethorarioAlmuerzo(false);
                    // }


                    //Aqui se verifica si el rango de horas es el mismo que el del almuerzo, y se consulta si deberia 

                    const solicitaPermisoEnHorarioAlmuerzo = CompareRangeBetweenDatesAlmuerzo(horaInicioAlmuerzo, horaFinAlmuerzo, horaDesdeSeleccionada, horaHastaSeleccionada) && diferenciaMinutos > tiempoAlmuerzoMinutos

                    const descuentaTiempoAlmuerzo = solicitaPermisoEnHorarioAlmuerzo && horaDesdeSeleccionada.getTime() <= horamaximaInicioAlmuerzo.getTime() && horaHastaSeleccionada.getTime() > horamaximaInicioAlmuerzo.getTime()// horaDesdeSeleccionada.getTime() <= horamaximaInicioAlmuerzo.getTime() && horaHastaSeleccionada.getTime() >= horamaximaFinalizaAlmuerzo.getTime();

                    const PreguntarIncluyeAlmuerzo1 = horaDesdeSeleccionada.getTime() >= horaInicioAlmuerzo.getTime() && horaHastaSeleccionada.getTime() <= horaFinAlmuerzo.getTime()



                    const PreguntarIncluyeAlmuerzo2 = horaDesdeSeleccionada.getTime() < horaInicioAlmuerzo.getTime() && horaHastaSeleccionada.getTime() >= horamaximaFinalizaAlmuerzo.getTime() && horaHastaSeleccionada.getTime() <= horamaximaInicioAlmuerzo.getTime();

                    const PreguntarIncluyeAlmuerzo3 = horaDesdeSeleccionada.getTime() >= horaInicioAlmuerzo.getTime() && horaDesdeSeleccionada.getTime() <= horamaximaInicioAlmuerzo.getTime() && horaHastaSeleccionada.getTime() > horamaximaInicioAlmuerzo.getTime()

                    const PermisoIncluyeTodaLaHoraAlmuerzo = (horaDesdeSeleccionada.getTime() <= horaInicioAlmuerzo.getTime() && horaFinAlmuerzo.getTime() <= horaHastaSeleccionada.getTime()) || (horaDesdeSeleccionada.getTime() <= horaInicioAlmuerzo.getTime() && horaHastaSeleccionada.getTime() === horaSalidaDelDia.getTime())

                    const PreguntarIncluyeAlmuerzo = (PreguntarIncluyeAlmuerzo1 || PreguntarIncluyeAlmuerzo2 || PreguntarIncluyeAlmuerzo3) && diferenciaMinutos > tiempoAlmuerzoMinutos && !PermisoIncluyeTodaLaHoraAlmuerzo
                    sethorarioAlmuerzo(PreguntarIncluyeAlmuerzo)

                    //Primero se verifica si es que no se pregunta al servidor si inclura el almuerzo y si esto no se hace porque no aplica su descuento de almuerzo.
                    // No se descuenta y de paso, se coloca la pregunta de si incluye almuerzo por default en no
                    if (!PreguntarIncluyeAlmuerzo && !descuentaTiempoAlmuerzo) {
                        setdescontadoTiempoAlmuerzo(false)
                        setincluyeHoraAlmuerzo(false)

                    }
                    else {
                        if ((incluyeHoraAlmuerzo || !PreguntarIncluyeAlmuerzo && descuentaTiempoAlmuerzo) && props.idRegimenLaboralSolicitaVacaciones != REGIMEN_USUARIO.LOES) {
                            valorRestarEnMinutos = tiempoAlmuerzoMinutos;
                            setdescontadoTiempoAlmuerzo(true)
                        }
                        else {
                            setdescontadoTiempoAlmuerzo(false)
                            setincluyeHoraAlmuerzo(false)
                        }
                    }






                    const diferenciaHoras = (+differenceInMinutes(horaHastaSeleccionada, horaDesdeSeleccionada) - valorRestarEnMinutos) / 60;

                    const diferencia = toHoursAndMinutes(diferenciaMinutos - valorRestarEnMinutos);
                    setHorasSolicitdas(diferencia);
                    const fraccionHoraDia = CalcularFraccionHoraDia(diferenciaHoras)
                    setfraccionHoraDia(fraccionHoraDia);
                }
            }





        }

    }, [fechaPermisoHora, horaDesde, horaHasta, diasPendientes, horarioAlmuerzo, mensajePermisoMedico, incluyeHoraAlmuerzo, horarioParaPermisoHora,horasPermisoHoraDelDia])

    useEffect(() => {


        if (fraccionHoraDia !== undefined && fraccionHoraDia >= 1) {
            seterrorHoras(MENSAJE_ERROR_DIA_COMPLETO_PERMISO_HORAS)
        }
        // else if (fraccionHoraDia !== undefined && fraccionHoraDia <= diasPendientes) {
        //     seterrorHoras("")
        // }
        else if (fraccionHoraDia !== undefined && fraccionHoraDia > diasPendientes) {
            seterrorHoras("No puede exceder el saldo de sus dias pendientes")
        }
    }, [horaDesde, horaHasta, fraccionHoraDia, diasPendientes])


    useEffect(() => {
        if (fechaPermisoHora !== null) {

            const VerificarHorarioLaboralEnFecha = async () => {
                setloadingHorarioPermisoHora(true)
                const respuesta = await ObtenerInformacionDiaPermiso(fechaPermisoHora);//await ObtenerHorarioLaboralEnFecha(fechaPermisoHora);
                if (respuesta.status === 200 && respuesta.dataResponse) {
                    sethorarioParaPermisoHora(respuesta.dataResponse.horarioServidor)
                    sethorasPermisoHoraDelDia(respuesta.dataResponse.horas)
                }
                setloadingHorarioPermisoHora(false)
            }

            VerificarHorarioLaboralEnFecha();
        }
        else {
            setHoraDesde("")
            setHoraHasta("")
            setfraccionHoraDia(undefined)
            setHorasSolicitdas(undefined)
            sethabilitarIngresoHoras(false)
            setjustificacionPermisoHora("")
            sethorarioAlmuerzo(false)
            setdescontadoTiempoAlmuerzo(false)
            sethorarioParaPermisoHora(undefined)

        }
    }, [fechaPermisoHora])


    useEffect(() => {
        if (horarioParaPermisoHora !== undefined) {
            sethabilitarIngresoHoras(true)
            setjustificacionPermisoHora(DEFAULT_JUSTIFICACION_PERMISO)

        }
    }, [horarioParaPermisoHora])



    if (stateCard.loadingCreacion) {
        return <Cargando
            mensaje='Creando Solicitud'
        />
    }



    return (
        <>
            <Card id="CardSolicitudes">
                <CardTitle className="cardHeaderSolicitudes">
                    <div>
                        Solicitudes de:
                    </div>
                </CardTitle>

                <CardBody className="cardBodyContenedorSolicitudes" style={{ padding: "0px !important" }}>
                    <div id="container-CBSolicitudes">
                        <Nav tabs className={"containerListadoTabs"}>
                            <NavItem className={"listadoTabs"}>
                                {TabNavegacion("Vacaciones Planificadas", TabSolicitudActiva.VACACIONES_PLANIFICADAS, false)}
                                {TabNavegacion("Permiso Imputable a vacaciones", TabSolicitudActiva.PERMISOS_IMPUTABLES, false)}
                                {TabNavegacion("Reintegro de vacaciones", TabSolicitudActiva.REINTEGRO, false)}
                                {TabNavegacion("Reprogramación", TabSolicitudActiva.REPROGRAMACION, false, "lastTab")}
                            </NavItem>

                        </Nav>

                        <TabContent activeTab={tabActiva}>
                            <TabPane tabId={TabSolicitudActiva.VACACIONES_PLANIFICADAS}>
                                <Row className="ContentTabSolicitudes">
                                    <Col sm="12">
                                        {WarnAlert}

                                        <p>Vacaciones Pendientes a la fecha: <strong>{diasPendientes} días ordinarios</strong> </p>
                                        {props.fechasLicencia.length > 0 && <p>Se encuentra en licencia/comisión desde <strong> {ObtenerFechaFromIsoFormat(props.fechasLicencia[0].fechadesde.toString())}  </strong>hasta el <strong> {ObtenerFechaFromIsoFormat(props.fechasLicencia[0].fechahasta.toString())} </strong></p>}
                                        <p><strong>Vacaciones por solicitar</strong></p>
                                        <Form autoComplete="off">
                                            <Row className="rowSolicitarPermisos">
                                                <Col md={3}>
                                                    <FormGroup>
                                                        <Label for="fechadesde">
                                                            Fecha desde
                                                        </Label>
                                                        {DatePickerInicio(false)}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={3}>
                                                    <FormGroup>
                                                        <Label for="fechahasta">
                                                            Fecha hasta
                                                        </Label>
                                                        {DatePickerFin(false)}
                                                    </FormGroup>
                                                </Col>
                                                <Col md={2}>
                                                    <FormGroup>
                                                        <Label for="diasSolicitados">
                                                            Días solicitados
                                                        </Label>
                                                        <Input type="text" value={GetDiferenciaSeleccion()} readOnly id="dias_pendientes_input_solicitud"></Input>
                                                    </FormGroup>
                                                </Col>
                                                {
                                                    saldoDias >= 0 && stateCard.fechaHasta !== undefined &&
                                                    <Col md={2}>
                                                        <FormGroup>
                                                            <Label for="diasSolicitados">
                                                                Saldo
                                                            </Label>
                                                            <Input type="text" value={saldoDias} readOnly id="saldo_dias_solicitudes"></Input>
                                                        </FormGroup>
                                                    </Col>
                                                }
                                                <Col md={2} className="align-self-end  mr-auto d-flex justify-content-start">

                                                    <Button disabled={stateCard.fechaDesde === null || ComponentePermisoCargoVacaciones !== undefined || ComponenteJustificarPlanificacionesNoEjecutadas !== undefined} className="primary" type="button" onClick={() => handleClickSolicitar()}>SOLICITAR </Button>


                                                </Col>

                                            </Row>
                                            {ComponenteJustificarPlanificacionesNoEjecutadas}

                                            <p><strong> Solicitudes Ingresadas</strong></p>
                                            {SolicitudesVacacionesPlanificadasDelUsuario}
                                            {SolicitudesReplanificacion}

                                        </Form>
                                    </Col>
                                </Row>
                            </TabPane>

                            <TabPane tabId={TabSolicitudActiva.PERMISOS_IMPUTABLES}>
                                <Row className="ContentTabSolicitudes permisos-imputables">
                                    <Col md={12}>
                                        <Nav tabs className={""}>
                                            <NavItem className={"listadoTabs permisos-imputables"}>
                                                {TabNavegacion("Días", TabSolicitudActiva.PERMISOS_IMPUTABLES_DIAS, true)}
                                                {TabNavegacion("Horas", TabSolicitudActiva.PERMISOS_IMPUTABLES_HORAS, true)}
                                            </NavItem>
                                        </Nav>
                                    </Col>
                                    <Col md={12}>
                                        <TabContent activeTab={subtabActiva}>
                                            <TabPane tabId={TabSolicitudActiva.PERMISOS_IMPUTABLES_DIAS}>
                                                {<Row className="ContentTabSolicitudes">
                                                    <Col sm="12">
                                                        {WarnAlert}

                                                        <p>Vacaciones Pendientes a la fecha: <strong>{diasPendientes} días ordinarios</strong> </p>
                                                        {props.fechasLicencia.length > 0 && <p>Se encuentra en licencia/comisión desde <strong> {ObtenerFechaFromIsoFormat(props.fechasLicencia[0].fechadesde.toString())}  </strong>hasta el <strong> {ObtenerFechaFromIsoFormat(props.fechasLicencia[0].fechahasta.toString())} </strong></p>}
                                                        {/* {MostrarPermisosIngresados(props.fechasPermisosMedicos)} */}
                                                        <p><strong>Permisos por solicitar</strong></p>
                                                        <Form autoComplete="off">
                                                            <Row className="rowSolicitarPermisos">
                                                                <Col md={3}>
                                                                    <FormGroup>
                                                                        <Label for="fechadesde">
                                                                            Fecha desde
                                                                        </Label>
                                                                        {DatePickerInicio(true)}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={3}>
                                                                    <FormGroup>
                                                                        <Label for="fechahasta">
                                                                            Fecha hasta
                                                                        </Label>
                                                                        {DatePickerFin(true)}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={2}>
                                                                    <FormGroup>
                                                                        <Label for="diasSolicitados">
                                                                            Días solicitados
                                                                        </Label>
                                                                        <Input type="text" value={(horaDesde !== undefined && horaDesde !== "") ? "" : GetDiferenciaSeleccion()} readOnly id="dias_pendientes_input_solicitud"></Input>
                                                                    </FormGroup>
                                                                </Col>
                                                                {
                                                                    saldoDias >= 0 && stateCard.fechaHasta !== undefined &&
                                                                    <Col md={2}>
                                                                        <FormGroup>
                                                                            <Label for="diasSolicitados">
                                                                                Saldo
                                                                            </Label>
                                                                            <Input type="text" value={saldoDias} readOnly id="saldo_dias_solicitudes"></Input>
                                                                        </FormGroup>
                                                                    </Col>
                                                                }
                                                                <Col md={2} className="align-self-end  mr-auto d-flex justify-content-start">

                                                                    <Button disabled={!props.puedeSolicitarPorHorario || ComponentePermisoCargoVacaciones !== undefined || ComponenteJustificarPlanificacionesNoEjecutadas !== undefined || +GetDiferenciaSeleccion() > props.nroMaximoDiasOrdinariosImputablesVacaciones} className="primary" type="button" onClick={() => handleClickSolicitar()}>SOLICITAR </Button>


                                                                </Col>


                                                            </Row>
                                                            {ComponenteJustificarPlanificacionesNoEjecutadas}

                                                            {ComponentePermisoCargoVacaciones}
                                                            {ErrorPermiso}
                                                            {SolicitudesPermisosDelUsuario}
                                                        </Form>
                                                    </Col>
                                                </Row>}
                                            </TabPane>
                                            <TabPane tabId={TabSolicitudActiva.PERMISOS_IMPUTABLES_HORAS}>
                                                <Row className="ContentTabSolicitudes">
                                                    <Col sm="12">
                                                        {WarnAlert}
                                                        <p>Vacaciones Pendientes a la fecha: <strong>{diasPendientes} días ordinarios</strong> </p>
                                                        {props.fechasLicencia.length > 0 && <p>Se encuentra en licencia/comisión desde <strong> {ObtenerFechaFromIsoFormat(props.fechasLicencia[0].fechadesde.toString())}  </strong>hasta el <strong> {ObtenerFechaFromIsoFormat(props.fechasLicencia[0].fechahasta.toString())} </strong></p>}
                                                        <p><strong>Permisos por solicitar</strong></p>
                                                        <Form autoComplete="off">
                                                            <Row className="rowErroresHoras">
                                                                <Col md={{ size: 12 }}>
                                                                    <small className='small-error '>{mensajePermisoMedico}</small>
                                                                </Col>
                                                            </Row>
                                                            <Row className="rowSolicitarPermisos">

                                                                <Col md={2}>
                                                                    <FormGroup>
                                                                        <Label for="fechaHora">
                                                                            Fecha
                                                                        </Label>
                                                                        {DatePickerFechaHora(true)}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={2}>
                                                                    <FormGroup>
                                                                        <Label for="horaDesde">
                                                                            Hora desde
                                                                        </Label>
                                                                        {inputHoraDesde()}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={2}>
                                                                    <FormGroup>
                                                                        <Label for="horaHasta">
                                                                            Hora hasta
                                                                        </Label>
                                                                        {inputHoraHasta()}
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={2}>
                                                                    <FormGroup>
                                                                        <Label for="diasSolicitados">
                                                                            Horas solicitadas
                                                                        </Label>
                                                                        <Input disabled={!habilitarIngresoHoras} type="text" value={horasSolicitadas === undefined ? "" : horasSolicitadas} readOnly id="horas_solicitadas"></Input>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={2}>
                                                                    <FormGroup>
                                                                        <Label for="diasSolicitados">
                                                                            Equivalencia Horas día
                                                                        </Label>
                                                                        <Input disabled={!habilitarIngresoHoras} type="text" value={fraccionHoraDia === undefined ? "" : fraccionHoraDia} readOnly id="fraccion_horas"></Input>
                                                                    </FormGroup>
                                                                </Col>
                                                                {
                                                                    saldoDias >= 0 && stateCard.fechaHasta !== undefined &&
                                                                    <Col md={{ size: 2 }}>
                                                                        <FormGroup>
                                                                            <Label for="diasSolicitados">
                                                                                Saldo
                                                                            </Label>
                                                                            <Input type="text" value={saldoDias} readOnly id="saldo_dias_solicitudes"></Input>
                                                                        </FormGroup>
                                                                    </Col>
                                                                }


                                                            </Row>
                                                            <Row className="rowErroresHoras">
                                                                <Col md={{ offset: 2, size: 6 }}>
                                                                    <small className='error-Vacaciones '>{errorHoras}</small>
                                                                </Col>
                                                            </Row>
                                                            {WarnAlertMensajeHorasAlmuerzo}
                                                            {ComponenteJustificarPlanificacionesNoEjecutadas}
                                                            {ComponentePermisoHorasCargoVacaciones}
                                                            {SolicitudesPermisosDelUsuario}
                                                        </Form>
                                                    </Col>
                                                </Row>
                                            </TabPane>
                                        </TabContent>
                                    </Col>




                                </Row>
                            </TabPane>
                            <TabPane tabId={TabSolicitudActiva.REINTEGRO}>
                                <Row className="ContentTabSolicitudes">
                                    <Col sm="12">
                                        <p>Vacaciones Pendientes a la fecha: <strong>{diasPendientes} días ordinarios</strong> </p>
                                        {props.fechasLicencia.length > 0 && <p>Se encuentra en licencia/comisión desde <strong> {ObtenerFechaFromIsoFormat(props.fechasLicencia[0].fechadesde.toString())}  </strong>hasta el <strong> {ObtenerFechaFromIsoFormat(props.fechasLicencia[0].fechahasta.toString())} </strong></p>}

                                        {SolicitudesReintegro}
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tabId={TabSolicitudActiva.REPROGRAMACION}>
                            </TabPane>
                        </TabContent>




                    </div>
                </CardBody>
            </Card>

            {
                ModalEliminarSolicitudesPermisosVacaciones
            }

            <ModalConfirmacion
                show={stateModalAnularReintegro.showModal && (stateModalAnularReintegro.solicitud?.idSolicitudReintegro ?? -1) > -1}
                size="lg"
                mensajeConfirmacion={'¿Desea eliminar la solicitud?'}
                classNamemensajeConfirmacion='mensajeConfirmacionAnulacionSolicitud'
                tituloModal='Eliminación de Solicitud'
                nombreBotonAccion='Aceptar'
                nombreBotonCerrarModal='Cancelar'
                onClose={() => setstateModalAnularReintegro(defaultStateModalAnulacionReintegro)}
                asyncAccion={true}
                asyncClose={true}

                closeAfterAccion={true}
                hideBotonCerrar={false}
                asyncOnClick={async () => AnularSolicitudReintegro(stateModalAnularReintegro.solicitud?.idSolicitudReintegro ?? -1)}
                asyncAfterOnClose={() => OnCloseModalConfirmacionAnulacion()}
                contentModal={stateModalAnularReintegro.content}
                classNameAllModal={""}

            />

            <ModalVistaPreviaDocumentosAccion
                show={stateModalFormulario.url !== "" || stateModalFormulario.loadingFormulario}
                accionOnAccept={true}
                cargandoDatos={stateModalFormulario.loadingFormulario}
                onClose={() => limpiarFechasCardYModal()}
                size="xl"
                tituloModal={stateModalFormulario.tituloModal}
                urlArchivo={stateModalFormulario.url}
                asyncAccion={async () => await OnClickAccionModalFormulario()}
                closeAfterAsync = {true}
                disabledbuttonCondition={stateModalFormulario.loadingFormulario}
                modalContent={stateModalFormulario.content}


            />

            <ModalVistaPreviaDocumentosAccion
                show={stateModalVistaPrevia.url !== "" || stateModalVistaPrevia.loadingContenido}
                accionOnAccept={false}
                cargandoDatos={stateModalVistaPrevia.loadingContenido}
                onClose={() => setStateModalVistaPrevia(defaultStateModalVistaPrevia)}
                size="xl"
                tituloModal={stateModalVistaPrevia.tituloModal}
                urlArchivo={stateModalVistaPrevia.url}
                enableDownload={true}
            />


            {
                ModalAnularSolicitudAprobada
            }
            {
                ModalSolicitarReintegro
            }
            {ModalEliminarSolicitudReplanificacion}
            {
                <ModalCargando
                    show = {loadingHorarioPermisoHora}
                    onClose={() => setloadingHorarioPermisoHora(false)}
                    size='md'
                    textoCargando='Consultando horario laboral de la fecha '
                />
            }
            {
                <ModalCargando
                    show = {loadingDetalleDiasSolicitud}
                    onClose={() => setloadingDetalleDiasSolicitud(false)}
                    size='md'
                    textoCargando='Consultando información en días solicitados '
                />
            }

        </>

    )
}

